// // // // pages/PayoutsPage.jsx
// // // import React, { useState, useEffect } from 'react';
// // // import {
// // //   FaSearch,
// // //   FaMoneyBillWave,
// // //   FaClock,
// // //   FaCheckCircle,
// // //   FaExclamationCircle,
// // //   FaEye,
// // //   FaPlus,
// // //   FaTimes,
// // //   FaUser,
// // //   FaReceipt,
// // //   FaProjectDiagram,
// // //   FaWallet,
// // //   FaBox,
// // //   FaSpinner,
// // // } from 'react-icons/fa';
// // // import withAuth from '../../auth/WithAuth';
// // // import { toast } from 'react-toastify';
// // // import './disbursements.scss';
// // // import { serverUrlAuth } from '../../../serverUrl';
// // // import FurnitureNavbar from '../../../components/layout/Nav';

// // // const PayoutsPage = () => {
// // //   const [activeTab, setActiveTab] = useState('custom');
// // //   const [payouts, setPayouts] = useState([]);
// // //   const [readyMadeEarnings, setReadyMadeEarnings] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [readyMadeLoading, setReadyMadeLoading] = useState(false);
// // //   const [showDisbursementModal, setShowDisbursementModal] = useState(false);
// // //   const [showDetailModal, setShowDetailModal] = useState(false);
// // //   const [selectedPayout, setSelectedPayout] = useState(null);
// // //   const [selectedReadyMadeEarning, setSelectedReadyMadeEarning] = useState(null);
// // //   const [payoutDetail, setPayoutDetail] = useState(null);
// // //   const [readyMadeDetail, setReadyMadeDetail] = useState(null);
// // //   const [detailLoading, setDetailLoading] = useState(false);
// // //   const [readyMadeDetailLoading, setReadyMadeDetailLoading] = useState(false);
// // //   const [filters, setFilters] = useState({
// // //     status: 'all',
// // //     search: '',
// // //   });
// // //   const [readyMadeFilters, setReadyMadeFilters] = useState({
// // //     search: '',
// // //   });
// // //   const [formData, setFormData] = useState({
// // //     amount: '',
// // //     payment_method: 'mpesa',
// // //     transaction_reference: '',
// // //     notes: '',
// // //   });
// // //   const [isSubmitting, setIsSubmitting] = useState(false);
// // //   const [formErrors, setFormErrors] = useState({});

// // //   // Stats
// // //   const [stats, setStats] = useState({
// // //     total: 0,
// // //     pending: 0,
// // //     partially_paid: 0,
// // //     paid: 0,
// // //   });
// // //   const [readyMadeStats, setReadyMadeStats] = useState({
// // //     total: 0,
// // //     pending: 0,
// // //     partially_paid: 0,
// // //     paid: 0,
// // //   });

// // //   useEffect(() => {
// // //     fetchPayouts();
// // //     fetchReadyMadeEarnings();
// // //   }, []);

// // //   // =============================================
// // //   // API HELPER FUNCTIONS
// // //   // =============================================

// // //   // Get the base URL for API calls
// // //   const getApiUrl = (endpoint) => {
// // //     // Assuming serverUrlAuth is already configured with base URL
// // //     return endpoint;
// // //   };

// // //   // GET request helper
// // //   const get = async (endpoint) => {
// // //     try {
// // //       const response = await serverUrlAuth.get(getApiUrl(endpoint));
// // //       return response.data;
// // //     } catch (error) {
// // //       console.error(`GET ${endpoint} error:`, error);
// // //       throw error;
// // //     }
// // //   };

// // //   // POST request helper
// // //   const post = async (endpoint, data) => {
// // //     try {
// // //       const response = await serverUrlAuth.post(getApiUrl(endpoint), data);
// // //       return response.data;
// // //     } catch (error) {
// // //       console.error(`POST ${endpoint} error:`, error);
// // //       throw error;
// // //     }
// // //   };

// // //   // =============================================
// // //   // API ENDPOINTS
// // //   // =============================================

// // //   // Custom project endpoints
// // //   const API = {
// // //     // Custom project payouts
// // //     custom: {
// // //       list: (status = 'all') => {
// // //         const url = status !== 'all' ? `disbursement/payouts/?status=${status}` : 'disbursement/payouts/';
// // //         return get(url);
// // //       },
// // //       detail: (id) => get(`disbursement/payouts/${id}/`),
// // //       disburse: (id, data) => post(`disbursement/payouts/${id}/disburse/`, data),
// // //     },

// // //     // Ready-made endpoints
// // //     readyMade: {
// // //       earnings: () => get('disbursement/admin/ready-made-disbursements/'),
// // //       detail: (id) => get(`disbursement/admin/ready-made-earnings/${id}/`),
// // //       disburse: (id, data) => post(`disbursement/admin/ready-made-earnings/${id}/disburse/`, data),
// // //     },
// // //   };

// // //   // =============================================
// // //   // FETCH FUNCTIONS
// // //   // =============================================

// // //   const fetchPayouts = async () => {
// // //     setLoading(true);
// // //     try {
// // //       const data = await API.custom.list(filters.status !== 'all' ? filters.status : 'all');

// // //       let payoutsData = data;
// // //       if (data.payouts && Array.isArray(data.payouts)) {
// // //         payoutsData = data.payouts;
// // //       }
// // //       if (!Array.isArray(payoutsData)) {
// // //         payoutsData = Object.values(payoutsData);
// // //       }

// // //       setPayouts(payoutsData);
// // //       updateStats(payoutsData);
// // //     } catch (error) {
// // //       console.error('Error fetching payouts:', error);
// // //       toast.error('Failed to load payouts');
// // //       setPayouts([]);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const fetchReadyMadeEarnings = async () => {
// // //     setReadyMadeLoading(true);
// // //     try {
// // //       const data = await API.readyMade.earnings();
// // //       const earningsData = data.earnings || [];
// // //       setReadyMadeEarnings(earningsData);
// // //       updateReadyMadeStats(earningsData);
// // //     } catch (error) {
// // //       console.error('Error fetching ready-made earnings:', error);
// // //       toast.error('Failed to load ready-made disbursements');
// // //       setReadyMadeEarnings([]);
// // //     } finally {
// // //       setReadyMadeLoading(false);
// // //     }
// // //   };

// // //   const fetchPayoutDetail = async (payoutId) => {
// // //     setDetailLoading(true);
// // //     try {
// // //       const data = await API.custom.detail(payoutId);
// // //       const detailData = data.payout ? { ...data.payout, disbursements: data.disbursements || [] } : data;
// // //       setPayoutDetail(detailData);
// // //     } catch (error) {
// // //       console.error('Error fetching payout details:', error);
// // //       toast.error('Failed to load payout details');
// // //     } finally {
// // //       setDetailLoading(false);
// // //     }
// // //   };

// // //   const fetchReadyMadeDetail = async (earningId) => {
// // //     setReadyMadeDetailLoading(true);
// // //     try {
// // //       const data = await API.readyMade.detail(earningId);
// // //       setReadyMadeDetail(data.earning || data);
// // //     } catch (error) {
// // //       console.error('Error fetching ready-made earning details:', error);
// // //       toast.error('Failed to load earning details');
// // //     } finally {
// // //       setReadyMadeDetailLoading(false);
// // //     }
// // //   };

// // //   // =============================================
// // //   // UI FUNCTIONS
// // //   // =============================================

// // //   const updateStats = (data) => {
// // //     const total = data.length;
// // //     const pending = data.filter(p => p.status === 'pending').length;
// // //     const partially_paid = data.filter(p => p.status === 'partially_paid').length;
// // //     const paid = data.filter(p => p.status === 'paid').length;
// // //     setStats({ total, pending, partially_paid, paid });
// // //   };

// // //   const updateReadyMadeStats = (data) => {
// // //     const total = data.length;
// // //     const pending = data.filter(e => e.status === 'pending').length;
// // //     const partially_paid = data.filter(e => e.status === 'partially_paid').length;
// // //     const paid = data.filter(e => e.status === 'paid').length;
// // //     setReadyMadeStats({ total, pending, partially_paid, paid });
// // //   };

// // //   const handleViewDetails = (payout) => {
// // //     setSelectedPayout(payout);
// // //     setShowDetailModal(true);
// // //     fetchPayoutDetail(payout.id);
// // //   };

// // //   const handleViewReadyMadeDetails = (earning) => {
// // //     setSelectedReadyMadeEarning(earning);
// // //     setShowDetailModal(true);
// // //     fetchReadyMadeDetail(earning.id);
// // //   };

// // //   const handleCloseDetailModal = () => {
// // //     setShowDetailModal(false);
// // //     setSelectedPayout(null);
// // //     setSelectedReadyMadeEarning(null);
// // //     setPayoutDetail(null);
// // //     setReadyMadeDetail(null);
// // //   };

// // //   const handleOpenDisbursement = (payout) => {
// // //     setSelectedPayout(payout);
// // //     // Reset form with correct values
// // //     const maxAmount = parseFloat(payout.amount_remaining) || 0;
// // //     setFormData({
// // //       amount: maxAmount > 0 ? maxAmount.toString() : '',
// // //       payment_method: 'mpesa',
// // //       transaction_reference: '',
// // //       notes: '',
// // //     });
// // //     setFormErrors({});
// // //     setShowDisbursementModal(true);
// // //   };

// // //   const handleOpenReadyMadeDisbursement = (earning) => {
// // //     setSelectedReadyMadeEarning(earning);
// // //     // Calculate remaining amount correctly
// // //     const netAmount = parseFloat(earning.net_amount) || 0;
// // //     const disbursed = parseFloat(earning.amount_disbursed) || 0;
// // //     const remaining = netAmount - disbursed;

// // //     // Reset form with correct values
// // //     setFormData({
// // //       amount: remaining > 0 ? remaining.toString() : '',
// // //       payment_method: 'mpesa',
// // //       transaction_reference: '',
// // //       notes: '',
// // //     });
// // //     setFormErrors({});
// // //     setShowDisbursementModal(true);
// // //   };

// // //   const handleCloseDisbursementModal = () => {
// // //     setShowDisbursementModal(false);
// // //     setSelectedPayout(null);
// // //     setSelectedReadyMadeEarning(null);
// // //     setFormData({
// // //       amount: '',
// // //       payment_method: 'mpesa',
// // //       transaction_reference: '',
// // //       notes: '',
// // //     });
// // //     setFormErrors({});
// // //   };

// // //   const handleInputChange = (e) => {
// // //     const { name, value } = e.target;
// // //     setFormData(prev => ({ ...prev, [name]: value }));
// // //     if (formErrors[name]) {
// // //       setFormErrors(prev => ({ ...prev, [name]: '' }));
// // //     }
// // //   };

// // //   const validateForm = () => {
// // //     const errors = {};
// // //     const amount = parseFloat(formData.amount);

// // //     // Get the correct max amount based on selection
// // //     let maxAmount = 0;
// // //     if (selectedPayout) {
// // //       maxAmount = parseFloat(selectedPayout.amount_remaining) || 0;
// // //     } else if (selectedReadyMadeEarning) {
// // //       const netAmount = parseFloat(selectedReadyMadeEarning.net_amount) || 0;
// // //       const disbursed = parseFloat(selectedReadyMadeEarning.amount_disbursed) || 0;
// // //       maxAmount = netAmount - disbursed;
// // //     }

// // //     if (!formData.amount) {
// // //       errors.amount = 'Amount is required';
// // //     } else if (isNaN(amount) || amount <= 0) {
// // //       errors.amount = 'Amount must be greater than 0';
// // //     } else if (amount > maxAmount) {
// // //       errors.amount = `Amount exceeds remaining balance (${formatCurrency(maxAmount)})`;
// // //     }

// // //     if (!formData.payment_method) {
// // //       errors.payment_method = 'Payment method is required';
// // //     }

// // //     if (!formData.transaction_reference) {
// // //       errors.transaction_reference = 'Transaction reference is required';
// // //     }

// // //     return errors;
// // //   };

// // //   const handleSubmitDisbursement = async (e) => {
// // //     e.preventDefault();

// // //     const errors = validateForm();
// // //     if (Object.keys(errors).length > 0) {
// // //       setFormErrors(errors);
// // //       return;
// // //     }

// // //     setIsSubmitting(true);
// // //     try {
// // //       const payload = {
// // //         amount: parseFloat(formData.amount),
// // //         payment_method: formData.payment_method,
// // //         transaction_reference: formData.transaction_reference,
// // //         notes: formData.notes,
// // //       };

// // //       let response;
// // //       if (selectedPayout) {
// // //         response = await API.custom.disburse(selectedPayout.id, payload);
// // //       } else if (selectedReadyMadeEarning) {
// // //         response = await API.readyMade.disburse(selectedReadyMadeEarning.id, payload);
// // //       } else {
// // //         toast.error('No payout selected');
// // //         return;
// // //       }

// // //       toast.success('Disbursement recorded successfully!');

// // //       if (selectedPayout) {
// // //         await fetchPayouts();
// // //       } else if (selectedReadyMadeEarning) {
// // //         await fetchReadyMadeEarnings();
// // //       }

// // //       handleCloseDisbursementModal();
// // //     } catch (error) {
// // //       console.error('Error recording disbursement:', error);
// // //       const errorMsg = error.response?.data?.error || 'Failed to record disbursement';
// // //       toast.error(errorMsg);
// // //     } finally {
// // //       setIsSubmitting(false);
// // //     }
// // //   };

// // //   // =============================================
// // //   // FILTERING
// // //   // =============================================

// // //   const filteredPayouts = payouts.filter(payout => {
// // //     if (filters.search) {
// // //       const search = filters.search.toLowerCase();
// // //       return (
// // //         payout.artisan_name?.toLowerCase().includes(search) ||
// // //         payout.project_name?.toLowerCase().includes(search) ||
// // //         payout.id?.toString().includes(search) ||
// // //         payout.artisan?.toString().includes(search)
// // //       );
// // //     }
// // //     return true;
// // //   });

// // //   const filteredReadyMadeEarnings = readyMadeEarnings.filter(earning => {
// // //     if (readyMadeFilters.search) {
// // //       const search = readyMadeFilters.search.toLowerCase();
// // //       return (
// // //         earning.id?.toString().includes(search) ||
// // //         earning.artisan_order?.id?.toString().includes(search) ||
// // //         earning.artisan?.name?.toLowerCase().includes(search) ||
// // //         earning.artisan?.email?.toLowerCase().includes(search)
// // //       );
// // //     }
// // //     return true;
// // //   });

// // //   // =============================================
// // //   // HELPERS
// // //   // =============================================

// // //   const getStatusConfig = (status) => {
// // //     const configs = {
// // //       pending: {
// // //         label: 'Pending',
// // //         icon: FaClock,
// // //         className: 'status-pending',
// // //         color: '#F59E0B',
// // //         bg: '#FEF3C7',
// // //       },
// // //       partially_paid: {
// // //         label: 'Partially Paid',
// // //         icon: FaExclamationCircle,
// // //         className: 'status-partial',
// // //         color: '#3B82F6',
// // //         bg: '#DBEAFE',
// // //       },
// // //       paid: {
// // //         label: 'Paid',
// // //         icon: FaCheckCircle,
// // //         className: 'status-paid',
// // //         color: '#10B981',
// // //         bg: '#D1FAE5',
// // //       },
// // //       cancelled: {
// // //         label: 'Cancelled',
// // //         icon: FaExclamationCircle,
// // //         className: 'status-cancelled',
// // //         color: '#EF4444',
// // //         bg: '#FEE2E2',
// // //       },
// // //     };
// // //     return configs[status] || configs.pending;
// // //   };

// // //   const getStageLabel = (stage) => {
// // //     const stages = {
// // //       'deposit': 'Deposit',
// // //       'deposit_initial': 'Deposit - Initial',
// // //       'deposit_progress': 'Deposit - Progress',
// // //       'balance_initial': 'Balance - Initial',
// // //       'balance_final': 'Balance - Final',
// // //     };
// // //     return stages[stage] || stage || 'N/A';
// // //   };

// // //   const formatCurrency = (amount) => {
// // //     if (amount === undefined || amount === null || isNaN(amount)) return 'KES 0.00';
// // //     return new Intl.NumberFormat('en-KE', {
// // //       style: 'currency',
// // //       currency: 'KES',
// // //       minimumFractionDigits: 2,
// // //     }).format(parseFloat(amount));
// // //   };

// // //   const formatDate = (date) => {
// // //     if (!date) return 'N/A';
// // //     try {
// // //       return new Date(date).toLocaleDateString('en-KE', {
// // //         year: 'numeric',
// // //         month: 'short',
// // //         day: 'numeric',
// // //         hour: '2-digit',
// // //         minute: '2-digit',
// // //       });
// // //     } catch {
// // //       return 'N/A';
// // //     }
// // //   };

// // //   // =============================================
// // //   // RENDER FUNCTIONS
// // //   // =============================================

// // //   const renderCustomDetail = () => {
// // //     // ... (same as before)
// // //     if (detailLoading) {
// // //       return (
// // //         <div className="detail-loading">
// // //           <div className="loading-spinner-small"></div>
// // //           <p>Loading details...</p>
// // //         </div>
// // //       );
// // //     }

// // //     if (!payoutDetail) {
// // //       return (
// // //         <div className="detail-error">
// // //           <p>Failed to load payout details.</p>
// // //         </div>
// // //       );
// // //     }

// // //     const StatusIcon = getStatusConfig(payoutDetail.status).icon;
// // //     const statusConfig = getStatusConfig(payoutDetail.status);

// // //     return (
// // //       <div className="detail-content">
// // //         <div className="detail-two-column">
// // //           <div className="detail-column-left">
// // //             <div className="detail-section">
// // //               <h3 className="section-title">
// // //                 <FaProjectDiagram /> Project Information
// // //               </h3>
// // //               <div className="detail-grid">
// // //                 <div className="detail-item">
// // //                   <span className="label">Project Name</span>
// // //                   <span className="value">{payoutDetail.project_name || 'N/A'}</span>
// // //                 </div>
// // //                 <div className="detail-item">
// // //                   <span className="label">Project ID</span>
// // //                   <span className="value">#{payoutDetail.project_id || 'N/A'}</span>
// // //                 </div>
// // //                 <div className="detail-item">
// // //                   <span className="label">Payment ID</span>
// // //                   <span className="value">#{payoutDetail.payment || 'N/A'}</span>
// // //                 </div>
// // //                 <div className="detail-item">
// // //                   <span className="label">Stage</span>
// // //                   <span className="value stage-badge">
// // //                     {getStageLabel(payoutDetail.payout_stage)}
// // //                   </span>
// // //                 </div>
// // //               </div>
// // //             </div>

// // //             <div className="detail-section">
// // //               <h3 className="section-title">
// // //                 <FaUser /> Artisan Information
// // //               </h3>
// // //               <div className="detail-grid">
// // //                 <div className="detail-item">
// // //                   <span className="label">Name</span>
// // //                   <span className="value">{payoutDetail.artisan_name || 'N/A'}</span>
// // //                 </div>
// // //                 <div className="detail-item">
// // //                   <span className="label">Artisan ID</span>
// // //                   <span className="value">#{payoutDetail.artisan || 'N/A'}</span>
// // //                 </div>
// // //                 <div className="detail-item">
// // //                   <span className="label">Status</span>
// // //                   <span className={`status-badge ${statusConfig.className}`}>
// // //                     <StatusIcon />
// // //                     {statusConfig.label}
// // //                   </span>
// // //                 </div>
// // //                 <div className="detail-item">
// // //                   <span className="label">Created</span>
// // //                   <span className="value">{formatDate(payoutDetail.created_at)}</span>
// // //                 </div>
// // //                 <div className="detail-item">
// // //                   <span className="label">Last Updated</span>
// // //                   <span className="value">{formatDate(payoutDetail.updated_at)}</span>
// // //                 </div>
// // //               </div>
// // //             </div>
// // //           </div>

// // //           <div className="detail-column-right">
// // //             <div className="detail-section">
// // //               <h3 className="section-title">
// // //                 <FaWallet /> Artisan Payment Details
// // //               </h3>
// // //               {payoutDetail.artisan_payment_details ? (
// // //                 <div className="payment-details-grid">
// // //                   <div className="payment-method-badge">
// // //                     <span className={`method-badge ${payoutDetail.artisan_payment_details.payment_method}`}>
// // //                       {payoutDetail.artisan_payment_details.payment_method === 'mpesa' ? '📱 M-Pesa' : '🏦 Bank Transfer'}
// // //                     </span>
// // //                   </div>

// // //                   {payoutDetail.artisan_payment_details.payment_method === 'mpesa' ? (
// // //                     <>
// // //                       <div className="detail-item">
// // //                         <span className="label">Phone Number</span>
// // //                         <span className="value">{payoutDetail.artisan_payment_details.mpesa_phone_number || 'N/A'}</span>
// // //                       </div>
// // //                       {payoutDetail.artisan_payment_details.mpesa_name && (
// // //                         <div className="detail-item">
// // //                           <span className="label">Account Name</span>
// // //                           <span className="value">{payoutDetail.artisan_payment_details.mpesa_name}</span>
// // //                         </div>
// // //                       )}
// // //                     </>
// // //                   ) : (
// // //                     <>
// // //                       <div className="detail-item">
// // //                         <span className="label">Bank Name</span>
// // //                         <span className="value">{payoutDetail.artisan_payment_details.bank_name || 'N/A'}</span>
// // //                       </div>
// // //                       <div className="detail-item">
// // //                         <span className="label">Account Name</span>
// // //                         <span className="value">{payoutDetail.artisan_payment_details.bank_account_name || 'N/A'}</span>
// // //                       </div>
// // //                       <div className="detail-item">
// // //                         <span className="label">Account Number</span>
// // //                         <span className="value account-number">{payoutDetail.artisan_payment_details.bank_account_number || 'N/A'}</span>
// // //                       </div>
// // //                       {payoutDetail.artisan_payment_details.bank_branch && (
// // //                         <div className="detail-item">
// // //                           <span className="label">Branch</span>
// // //                           <span className="value">{payoutDetail.artisan_payment_details.bank_branch}</span>
// // //                         </div>
// // //                       )}
// // //                     </>
// // //                   )}
// // //                 </div>
// // //               ) : (
// // //                 <p className="no-payment-details">No payment details available for this artisan.</p>
// // //               )}
// // //             </div>

// // //             <div className="detail-section">
// // //               <h3 className="section-title">
// // //                 <FaMoneyBillWave /> Financial Summary
// // //               </h3>
// // //               <div className="financial-grid">
// // //                 <div className="financial-item">
// // //                   <span className="label">Gross Amount</span>
// // //                   <span className="value">{formatCurrency(payoutDetail.gross_amount)}</span>
// // //                 </div>
// // //                 <div className="financial-item">
// // //                   <span className="label">Commission</span>
// // //                   <span className="value text-muted">{formatCurrency(payoutDetail.commission_amount)}</span>
// // //                 </div>
// // //                 <div className="financial-item highlight">
// // //                   <span className="label">Artisan Amount</span>
// // //                   <span className="value">{formatCurrency(payoutDetail.artisan_amount)}</span>
// // //                 </div>
// // //                 <div className="financial-item">
// // //                   <span className="label">Amount Disbursed</span>
// // //                   <span className="value text-success">{formatCurrency(payoutDetail.amount_disbursed)}</span>
// // //                 </div>
// // //                 <div className="financial-item highlight-remaining">
// // //                   <span className="label">Amount Remaining</span>
// // //                   <span className="value">{formatCurrency(payoutDetail.amount_remaining)}</span>
// // //                 </div>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>

// // //         {payoutDetail.disbursements && payoutDetail.disbursements.length > 0 ? (
// // //           <div className="detail-section full-width">
// // //             <h3 className="section-title">
// // //               <FaReceipt /> Disbursement History
// // //             </h3>
// // //             <div className="disbursement-list">
// // //               {payoutDetail.disbursements.map((disb, index) => (
// // //                 <div key={disb.id} className="disbursement-item">
// // //                   <div className="disb-header">
// // //                     <span className="disb-number">#{index + 1}</span>
// // //                     <span className="disb-amount">{formatCurrency(disb.amount)}</span>
// // //                     <span className={`disb-method ${disb.payment_method}`}>
// // //                       {disb.payment_method === 'mpesa' ? '📱 M-Pesa' : '🏦 Bank Transfer'}
// // //                     </span>
// // //                   </div>
// // //                   <div className="disb-details">
// // //                     <span><strong>Reference:</strong> {disb.transaction_reference}</span>
// // //                     <span><strong>Date:</strong> {formatDate(disb.disbursed_at)}</span>
// // //                     {disb.recorded_by_name && (
// // //                       <span><strong>Recorded by:</strong> {disb.recorded_by_name}</span>
// // //                     )}
// // //                   </div>
// // //                   {disb.notes && (
// // //                     <div className="disb-notes">
// // //                       <strong>Notes:</strong> {disb.notes}
// // //                     </div>
// // //                   )}
// // //                 </div>
// // //               ))}
// // //             </div>
// // //           </div>
// // //         ) : (
// // //           <div className="detail-section full-width">
// // //             <p className="no-disbursements">No disbursements recorded yet.</p>
// // //           </div>
// // //         )}
// // //       </div>
// // //     );
// // //   };

// // //   const renderReadyMadeDetail = () => {
// // //     if (readyMadeDetailLoading) {
// // //       return (
// // //         <div className="detail-loading">
// // //           <div className="loading-spinner-small"></div>
// // //           <p>Loading details...</p>
// // //         </div>
// // //       );
// // //     }

// // //     if (!readyMadeDetail) {
// // //       return (
// // //         <div className="detail-error">
// // //           <p>Failed to load earning details.</p>
// // //         </div>
// // //       );
// // //     }

// // //     const earning = readyMadeDetail;
// // //     const statusConfig = getStatusConfig(earning.status || 'pending');
// // //     const StatusIcon = statusConfig.icon;

// // //     return (
// // //       <div className="ready-made-detail-content">
// // //         <div className="earning-summary-header">
// // //           <div className="earning-main-info">
// // //             <div className="earning-id-badge">Earning #{earning.id || 'N/A'}</div>
// // //             <div className="earning-amount-large">
// // //               {formatCurrency(earning.net_amount || 0)}
// // //             </div>
// // //             <div className="earning-status">
// // //               <span
// // //                 className="status-badge-large"
// // //                 style={{
// // //                   background: statusConfig.bg || '#f0f0f0',
// // //                   color: statusConfig.color || '#666',
// // //                 }}
// // //               >
// // //                 <StatusIcon />
// // //                 {statusConfig.label}
// // //               </span>
// // //             </div>
// // //           </div>
// // //         </div>

// // //         <div className="financial-breakdown">
// // //           <h4>Financial Breakdown</h4>
// // //           <div className="breakdown-grid">
// // //             <div className="breakdown-item">
// // //               <span className="breakdown-label">Gross Amount</span>
// // //               <span className="breakdown-value">{formatCurrency(earning.gross_amount || 0)}</span>
// // //             </div>
// // //             <div className="breakdown-item">
// // //               <span className="breakdown-label">Commission Amount</span>
// // //               <span className="breakdown-value negative">-{formatCurrency(earning.commission_amount || 0)}</span>
// // //             </div>
// // //             <div className="breakdown-item total">
// // //               <span className="breakdown-label">Net Amount</span>
// // //               <span className="breakdown-value total">{formatCurrency(earning.net_amount || 0)}</span>
// // //             </div>
// // //             <div className="breakdown-item">
// // //               <span className="breakdown-label">Amount Disbursed</span>
// // //               <span className="breakdown-value">{formatCurrency(earning.amount_disbursed || 0)}</span>
// // //             </div>
// // //             <div className="breakdown-item">
// // //               <span className="breakdown-label">Amount Remaining</span>
// // //               <span className="breakdown-value">{formatCurrency(earning.amount_remaining || 0)}</span>
// // //             </div>
// // //           </div>
// // //         </div>

// // //         <div className="order-information">
// // //           <h4>Order Information</h4>
// // //           <div className="info-grid">
// // //             <div className="info-item">
// // //               <span className="info-label">Artisan Order ID</span>
// // //               <span className="info-value">#{earning.artisan_order?.id || 'N/A'}</span>
// // //             </div>
// // //             <div className="info-item">
// // //               <span className="info-label">Artisan Name</span>
// // //               <span className="info-value">{earning.artisan?.name || 'N/A'}</span>
// // //             </div>
// // //             <div className="info-item">
// // //               <span className="info-label">Artisan Email</span>
// // //               <span className="info-value">{earning.artisan?.email || 'N/A'}</span>
// // //             </div>
// // //             <div className="info-item">
// // //               <span className="info-label">Created At</span>
// // //               <span className="info-value">{formatDate(earning.created_at)}</span>
// // //             </div>
// // //             {earning.paid_at && (
// // //               <div className="info-item">
// // //                 <span className="info-label">Paid At</span>
// // //                 <span className="info-value">{formatDate(earning.paid_at)}</span>
// // //               </div>
// // //             )}
// // //           </div>
// // //         </div>
// // //       </div>
// // //     );
// // //   };

// // //   // =============================================
// // //   // MAIN RENDER
// // //   // =============================================

// // //   const renderContent = () => {
// // //     if (activeTab === 'custom') {
// // //       return renderCustomTab();
// // //     } else {
// // //       return renderReadyMadeTab();
// // //     }
// // //   };

// // //   const renderCustomTab = () => {
// // //     if (loading) {
// // //       return (
// // //         <div className="loading-container">
// // //           <div className="loading-spinner"></div>
// // //           <p>Loading payouts...</p>
// // //         </div>
// // //       );
// // //     }

// // //     return (
// // //       <>
// // //         <div className="stats-overview">
// // //           <div className="stat-card total">
// // //             <div className="stat-icon"><FaMoneyBillWave /></div>
// // //             <div className="stat-info">
// // //               <h3>Total Payouts</h3>
// // //               <p className="stat-value">{stats.total}</p>
// // //             </div>
// // //           </div>
// // //           <div className="stat-card pending">
// // //             <div className="stat-icon"><FaClock /></div>
// // //             <div className="stat-info">
// // //               <h3>Pending</h3>
// // //               <p className="stat-value">{stats.pending}</p>
// // //             </div>
// // //           </div>
// // //           <div className="stat-card partial">
// // //             <div className="stat-icon"><FaExclamationCircle /></div>
// // //             <div className="stat-info">
// // //               <h3>Partially Paid</h3>
// // //               <p className="stat-value">{stats.partially_paid}</p>
// // //             </div>
// // //           </div>
// // //           <div className="stat-card paid">
// // //             <div className="stat-icon"><FaCheckCircle /></div>
// // //             <div className="stat-info">
// // //               <h3>Fully Paid</h3>
// // //               <p className="stat-value">{stats.paid}</p>
// // //             </div>
// // //           </div>
// // //         </div>

// // //         <div className="filters-section">
// // //           <div className="filters-bar">
// // //             <div className="search-box">
// // //               <FaSearch className="search-icon" />
// // //               <input
// // //                 type="text"
// // //                 placeholder="Search artisan, project, or payout ID..."
// // //                 value={filters.search}
// // //                 onChange={(e) => setFilters(prev => ({ ...prev, search: e.target.value }))}
// // //               />
// // //             </div>
// // //             <div className="filter-group">
// // //               <select
// // //                 value={filters.status}
// // //                 onChange={(e) => setFilters(prev => ({ ...prev, status: e.target.value }))}
// // //               >
// // //                 <option value="all">All Status</option>
// // //                 <option value="pending">Pending</option>
// // //                 <option value="partially_paid">Partially Paid</option>
// // //                 <option value="paid">Paid</option>
// // //                 <option value="cancelled">Cancelled</option>
// // //               </select>
// // //             </div>
// // //             <div className="filter-actions">
// // //               <span className="results-count">
// // //                 {filteredPayouts.length} of {payouts.length} payouts
// // //               </span>
// // //             </div>
// // //           </div>
// // //         </div>

// // //         <div className="table-section">
// // //           <div className="table-container">
// // //             {filteredPayouts.length === 0 ? (
// // //               <div className="empty-state">
// // //                 <div className="empty-icon">💰</div>
// // //                 <h3>No payouts found</h3>
// // //                 <p>No payouts match your current filter criteria.</p>
// // //               </div>
// // //             ) : (
// // //               <table className="payouts-table">
// // //                 <thead>
// // //                   <tr>
// // //                     <th>Artisan</th>
// // //                     <th>Project</th>
// // //                     <th>Stage</th>
// // //                     <th>Total Amount</th>
// // //                     <th>Disbursed</th>
// // //                     <th>Remaining</th>
// // //                     <th>Status</th>
// // //                     <th>Date</th>
// // //                     <th>Actions</th>
// // //                   </tr>
// // //                 </thead>
// // //                 <tbody>
// // //                   {filteredPayouts.map((payout) => {
// // //                     const StatusIcon = getStatusConfig(payout.status).icon;
// // //                     const statusConfig = getStatusConfig(payout.status);

// // //                     return (
// // //                       <tr key={payout.id} className={payout.status}>
// // //                         <td>
// // //                           <div className="artisan-info">
// // //                             <div className="artisan-avatar">
// // //                               {payout.artisan_name?.charAt(0) || 'A'}
// // //                             </div>
// // //                             <div className="artisan-details">
// // //                               <strong>{payout.artisan_name || `Artisan #${payout.artisan}`}</strong>
// // //                               <span>ID: #{payout.id}</span>
// // //                             </div>
// // //                           </div>
// // //                         </td>
// // //                         <td>
// // //                           <div className="project-info">
// // //                             <strong>{payout.project_name || 'N/A'}</strong>
// // //                             <span className="project-id">Project #{payout.project_id || 'N/A'}</span>
// // //                           </div>
// // //                         </td>
// // //                         <td>
// // //                           <span className="stage-badge">
// // //                             {getStageLabel(payout.payout_stage)}
// // //                           </span>
// // //                         </td>
// // //                         <td className="amount-column">
// // //                           <span className="gross-amount">
// // //                             {formatCurrency(payout.gross_amount)}
// // //                           </span>
// // //                           <small className="commission">
// // //                             Commission: {formatCurrency(payout.commission_amount)}
// // //                           </small>
// // //                         </td>
// // //                         <td className="amount-column">
// // //                           <span className="disbursed-amount">
// // //                             {formatCurrency(payout.amount_disbursed)}
// // //                           </span>
// // //                         </td>
// // //                         <td className="amount-column">
// // //                           <span className={`remaining-amount ${parseFloat(payout.amount_remaining) === 0 ? 'zero' : ''}`}>
// // //                             {formatCurrency(payout.amount_remaining)}
// // //                           </span>
// // //                         </td>
// // //                         <td>
// // //                           <span className={`status-badge ${statusConfig.className}`}>
// // //                             <StatusIcon />
// // //                             {statusConfig.label}
// // //                           </span>
// // //                         </td>
// // //                         <td>
// // //                           <span className="date-text">
// // //                             {formatDate(payout.created_at)}
// // //                           </span>
// // //                         </td>
// // //                         <td>
// // //                           <div className="action-buttons">
// // //                             <button
// // //                               className="btn btn-sm btn-view"
// // //                               onClick={() => handleViewDetails(payout)}
// // //                               title="View Details"
// // //                             >
// // //                               <FaEye /> View
// // //                             </button>
// // //                             {payout.status !== 'paid' && payout.status !== 'cancelled' && (
// // //                               <button
// // //                                 className="btn btn-sm btn-disburse"
// // //                                 onClick={() => handleOpenDisbursement(payout)}
// // //                                 title="Record Disbursement"
// // //                               >
// // //                                 <FaPlus /> Pay
// // //                               </button>
// // //                             )}
// // //                           </div>
// // //                         </td>
// // //                       </tr>
// // //                     );
// // //                   })}
// // //                 </tbody>
// // //               </table>
// // //             )}
// // //           </div>
// // //           <div className="table-footer">
// // //             <div className="footer-info">
// // //               Showing {filteredPayouts.length} of {payouts.length} payouts
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </>
// // //     );
// // //   };

// // //   const renderReadyMadeTab = () => {
// // //     if (readyMadeLoading) {
// // //       return (
// // //         <div className="loading-container">
// // //           <div className="loading-spinner"></div>
// // //           <p>Loading ready-made disbursements...</p>
// // //         </div>
// // //       );
// // //     }

// // //     return (
// // //       <>
// // //         <div className="stats-overview">
// // //           <div className="stat-card total">
// // //             <div className="stat-icon"><FaBox /></div>
// // //             <div className="stat-info">
// // //               <h3>Total Orders</h3>
// // //               <p className="stat-value">{readyMadeStats.total}</p>
// // //             </div>
// // //           </div>
// // //           <div className="stat-card pending">
// // //             <div className="stat-icon"><FaClock /></div>
// // //             <div className="stat-info">
// // //               <h3>Pending</h3>
// // //               <p className="stat-value">{readyMadeStats.pending}</p>
// // //             </div>
// // //           </div>
// // //           <div className="stat-card partial">
// // //             <div className="stat-icon"><FaExclamationCircle /></div>
// // //             <div className="stat-info">
// // //               <h3>Partially Paid</h3>
// // //               <p className="stat-value">{readyMadeStats.partially_paid}</p>
// // //             </div>
// // //           </div>
// // //           <div className="stat-card paid">
// // //             <div className="stat-icon"><FaCheckCircle /></div>
// // //             <div className="stat-info">
// // //               <h3>Paid</h3>
// // //               <p className="stat-value">{readyMadeStats.paid}</p>
// // //             </div>
// // //           </div>
// // //         </div>

// // //         <div className="filters-section">
// // //           <div className="filters-bar">
// // //             <div className="search-box">
// // //               <FaSearch className="search-icon" />
// // //               <input
// // //                 type="text"
// // //                 placeholder="Search by earning ID, artisan, or order..."
// // //                 value={readyMadeFilters.search}
// // //                 onChange={(e) => setReadyMadeFilters(prev => ({ ...prev, search: e.target.value }))}
// // //               />
// // //             </div>
// // //             <div className="filter-actions">
// // //               <span className="results-count">
// // //                 {filteredReadyMadeEarnings.length} of {readyMadeEarnings.length} earnings
// // //               </span>
// // //             </div>
// // //           </div>
// // //         </div>

// // //         <div className="table-section">
// // //           <div className="table-container">
// // //             {filteredReadyMadeEarnings.length === 0 ? (
// // //               <div className="empty-state">
// // //                 <div className="empty-icon">📦</div>
// // //                 <h3>No ready-made earnings found</h3>
// // //                 <p>No ready-made orders have been processed yet.</p>
// // //               </div>
// // //             ) : (
// // //               <table className="payouts-table">
// // //                 <thead>
// // //                   <tr>
// // //                     <th>Earning ID</th>
// // //                     <th>Artisan</th>
// // //                     <th>Gross Amount</th>
// // //                     <th>Commission</th>
// // //                     <th>Net Amount</th>
// // //                     <th>Disbursed</th>
// // //                     <th>Remaining</th>
// // //                     <th>Status</th>
// // //                     <th>Date</th>
// // //                     <th>Actions</th>
// // //                   </tr>
// // //                 </thead>
// // //                 <tbody>
// // //                   {filteredReadyMadeEarnings.map((earning) => {
// // //                     const statusConfig = getStatusConfig(earning.status || 'pending');
// // //                     const StatusIcon = statusConfig.icon;

// // //                     return (
// // //                       <tr key={earning.id}>
// // //                         <td>
// // //                           <div className="order-id">
// // //                             <strong>#{earning.id}</strong>
// // //                           </div>
// // //                         </td>
// // //                         <td>
// // //                           <div className="artisan-info">
// // //                             <div className="artisan-avatar">
// // //                               {earning.artisan?.name?.charAt(0) || 'A'}
// // //                             </div>
// // //                             <div className="artisan-details">
// // //                               <strong>{earning.artisan?.name || 'N/A'}</strong>
// // //                               <span>{earning.artisan?.email || ''}</span>
// // //                             </div>
// // //                           </div>
// // //                         </td>
// // //                         <td className="amount-column">
// // //                           <span className="gross-amount">
// // //                             {formatCurrency(earning.gross_amount || 0)}
// // //                           </span>
// // //                         </td>
// // //                         <td className="amount-column">
// // //                           <span className="commission-amount">
// // //                             {formatCurrency(earning.commission_amount || 0)}
// // //                           </span>
// // //                         </td>
// // //                         <td className="amount-column">
// // //                           <span className="net-amount">
// // //                             {formatCurrency(earning.net_amount || 0)}
// // //                           </span>
// // //                         </td>
// // //                         <td className="amount-column">
// // //                           <span className="disbursed-amount">
// // //                             {formatCurrency(earning.amount_disbursed || 0)}
// // //                           </span>
// // //                         </td>
// // //                         <td className="amount-column">
// // //                           <span className={`remaining-amount ${parseFloat(earning.amount_remaining || 0) === 0 ? 'zero' : ''}`}>
// // //                             {formatCurrency(earning.amount_remaining || 0)}
// // //                           </span>
// // //                         </td>
// // //                         <td>
// // //                           <span className={`status-badge ${statusConfig.className}`}>
// // //                             <StatusIcon />
// // //                             {statusConfig.label}
// // //                           </span>
// // //                         </td>
// // //                         <td>
// // //                           <span className="date-text">
// // //                             {formatDate(earning.created_at)}
// // //                           </span>
// // //                         </td>
// // //                         <td>
// // //                           <div className="action-buttons">
// // //                             <button
// // //                               className="btn btn-sm btn-view"
// // //                               onClick={() => handleViewReadyMadeDetails(earning)}
// // //                               title="View Details"
// // //                             >
// // //                               <FaEye /> View
// // //                             </button>
// // //                             {earning.status !== 'paid' && (
// // //                               <button
// // //                                 className="btn btn-sm btn-disburse"
// // //                                 onClick={() => handleOpenReadyMadeDisbursement(earning)}
// // //                                 title="Record Disbursement"
// // //                               >
// // //                                 <FaPlus /> Pay
// // //                               </button>
// // //                             )}
// // //                           </div>
// // //                         </td>
// // //                       </tr>
// // //                     );
// // //                   })}
// // //                 </tbody>
// // //               </table>
// // //             )}
// // //           </div>
// // //           <div className="table-footer">
// // //             <div className="footer-info">
// // //               Showing {filteredReadyMadeEarnings.length} of {readyMadeEarnings.length} earnings
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </>
// // //     );
// // //   };

// // //   return (
// // //     <>
// // //       <FurnitureNavbar />
// // //       <div className="payouts-page">
// // //         <div className="page-header">
// // //           <div className="header-content">
// // //             <div className="header-text">
// // //               <h1>💰 Payout Management</h1>
// // //               <p>Manage artisan payouts and track disbursements</p>
// // //             </div>
// // //             <div className="header-actions">
// // //               <button className="btn btn-refresh" onClick={() => {
// // //                 if (activeTab === 'custom') {
// // //                   fetchPayouts();
// // //                 } else {
// // //                   fetchReadyMadeEarnings();
// // //                 }
// // //               }}>
// // //                 Refresh
// // //               </button>
// // //             </div>
// // //           </div>
// // //         </div>

// // //         <div className="tabs-container">
// // //           <button
// // //             className={`tab-btn ${activeTab === 'custom' ? 'active' : ''}`}
// // //             onClick={() => setActiveTab('custom')}
// // //           >
// // //             <FaProjectDiagram /> Custom Projects
// // //           </button>
// // //           <button
// // //             className={`tab-btn ${activeTab === 'ready-made' ? 'active' : ''}`}
// // //             onClick={() => setActiveTab('ready-made')}
// // //           >
// // //             <FaBox /> Ready-Made Orders
// // //           </button>
// // //         </div>

// // //         {renderContent()}

// // //         {/* Detail Modal */}
// // //         {showDetailModal && (
// // //           <div className="modal-overlay" onClick={handleCloseDetailModal}>
// // //             <div className="modal-content detail-modal" onClick={e => e.stopPropagation()}>
// // //               <div className="modal-header">
// // //                 <div className="modal-title">
// // //                   <FaMoneyBillWave className="modal-icon" />
// // //                   <div>
// // //                     <h2>
// // //                       {activeTab === 'custom'
// // //                         ? `Payout Details - #${selectedPayout?.id || ''}`
// // //                         : `Earning Details - #${selectedReadyMadeEarning?.id || ''}`
// // //                       }
// // //                     </h2>
// // //                     <p>
// // //                       {activeTab === 'custom'
// // //                         ? selectedPayout?.artisan_name || 'Custom Project'
// // //                         : 'Ready-Made Order'
// // //                       }
// // //                     </p>
// // //                   </div>
// // //                 </div>
// // //                 <button className="close-modal" onClick={handleCloseDetailModal}>
// // //                   <FaTimes />
// // //                 </button>
// // //               </div>

// // //               {activeTab === 'custom' ? renderCustomDetail() : renderReadyMadeDetail()}

// // //               <div className="modal-footer">
// // //                 <button className="btn btn-secondary" onClick={handleCloseDetailModal}>
// // //                   Close
// // //                 </button>
// // //                 {activeTab === 'custom' && selectedPayout?.status !== 'paid' && selectedPayout?.status !== 'cancelled' && (
// // //                   <button
// // //                     className="btn btn-primary"
// // //                     onClick={() => {
// // //                       handleCloseDetailModal();
// // //                       handleOpenDisbursement(selectedPayout);
// // //                     }}
// // //                   >
// // //                     <FaPlus /> Record Payment
// // //                   </button>
// // //                 )}
// // //                 {activeTab === 'ready-made' && selectedReadyMadeEarning && selectedReadyMadeEarning.status !== 'paid' && (
// // //                   <button
// // //                     className="btn btn-primary"
// // //                     onClick={() => {
// // //                       handleCloseDetailModal();
// // //                       handleOpenReadyMadeDisbursement(selectedReadyMadeEarning);
// // //                     }}
// // //                   >
// // //                     <FaPlus /> Record Payment
// // //                   </button>
// // //                 )}
// // //               </div>
// // //             </div>
// // //           </div>
// // //         )}

// // //         {/* Disbursement Modal */}
// // //         {showDisbursementModal && (selectedPayout || selectedReadyMadeEarning) && (
// // //           <div className="modal-overlay" onClick={handleCloseDisbursementModal}>
// // //             <div className="modal-content" onClick={e => e.stopPropagation()}>
// // //               <div className="modal-header">
// // //                 <div className="modal-title">
// // //                   <FaMoneyBillWave className="modal-icon" />
// // //                   <div>
// // //                     <h2>Record Disbursement</h2>
// // //                     <p>
// // //                       {selectedPayout
// // //                         ? `Recording payment for ${selectedPayout.artisan_name || `Artisan #${selectedPayout.artisan}`}`
// // //                         : `Recording payment for ${selectedReadyMadeEarning?.artisan?.name || 'Artisan'}`
// // //                       }
// // //                     </p>
// // //                   </div>
// // //                 </div>
// // //                 <button className="close-modal" onClick={handleCloseDisbursementModal}>
// // //                   <FaTimes />
// // //                 </button>
// // //               </div>

// // //               <form onSubmit={handleSubmitDisbursement}>
// // //                 <div className="payout-summary">
// // //                   <div className="summary-item">
// // //                     <span className="label">Total Amount</span>
// // //                     <span className="value">
// // //                       {selectedPayout
// // //                         ? formatCurrency(selectedPayout.artisan_amount)
// // //                         : formatCurrency(selectedReadyMadeEarning?.net_amount || 0)
// // //                       }
// // //                     </span>
// // //                   </div>
// // //                   <div className="summary-item">
// // //                     <span className="label">Already Disbursed</span>
// // //                     <span className="value">
// // //                       {selectedPayout
// // //                         ? formatCurrency(selectedPayout.amount_disbursed)
// // //                         : formatCurrency(selectedReadyMadeEarning?.amount_disbursed || 0)
// // //                       }
// // //                     </span>
// // //                   </div>
// // //                   <div className="summary-item highlight">
// // //                     <span className="label">Remaining</span>
// // //                     <span className="value">
// // //                       {selectedPayout
// // //                         ? formatCurrency(selectedPayout.amount_remaining)
// // //                         : formatCurrency(
// // //                             (parseFloat(selectedReadyMadeEarning?.net_amount) || 0) -
// // //                             (parseFloat(selectedReadyMadeEarning?.amount_disbursed) || 0)
// // //                           )
// // //                       }
// // //                     </span>
// // //                   </div>
// // //                 </div>

// // //                 <div className="form-group">
// // //                   <label htmlFor="amount">
// // //                     Amount <span className="required">*</span>
// // //                   </label>
// // //                   <div className="input-with-icon">
// // //                     <span className="currency-icon">KES</span>
// // //                     <input
// // //                       type="number"
// // //                       id="amount"
// // //                       name="amount"
// // //                       value={formData.amount}
// // //                       onChange={handleInputChange}
// // //                       placeholder="Enter amount to disburse"
// // //                       step="0.01"
// // //                       min="0.01"
// // //                       className={formErrors.amount ? 'error' : ''}
// // //                       disabled={isSubmitting}
// // //                     />
// // //                   </div>
// // //                   {formErrors.amount && (
// // //                     <span className="error-message">{formErrors.amount}</span>
// // //                   )}
// // //                   <small className="hint">
// // //                     Maximum: {formatCurrency(
// // //                       selectedPayout
// // //                         ? selectedPayout.amount_remaining
// // //                         : (parseFloat(selectedReadyMadeEarning?.net_amount) || 0) -
// // //                           (parseFloat(selectedReadyMadeEarning?.amount_disbursed) || 0)
// // //                     )}
// // //                   </small>
// // //                 </div>

// // //                 <div className="form-group">
// // //                   <label htmlFor="payment_method">
// // //                     Payment Method <span className="required">*</span>
// // //                   </label>
// // //                   <select
// // //                     id="payment_method"
// // //                     name="payment_method"
// // //                     value={formData.payment_method}
// // //                     onChange={handleInputChange}
// // //                     className={formErrors.payment_method ? 'error' : ''}
// // //                     disabled={isSubmitting}
// // //                   >
// // //                     <option value="mpesa">M-Pesa</option>
// // //                     <option value="bank">Bank Transfer</option>
// // //                   </select>
// // //                   {formErrors.payment_method && (
// // //                     <span className="error-message">{formErrors.payment_method}</span>
// // //                   )}
// // //                 </div>

// // //                 <div className="form-group">
// // //                   <label htmlFor="transaction_reference">
// // //                     Transaction Reference <span className="required">*</span>
// // //                   </label>
// // //                   <input
// // //                     type="text"
// // //                     id="transaction_reference"
// // //                     name="transaction_reference"
// // //                     value={formData.transaction_reference}
// // //                     onChange={handleInputChange}
// // //                     placeholder="Enter transaction reference"
// // //                     className={formErrors.transaction_reference ? 'error' : ''}
// // //                     disabled={isSubmitting}
// // //                   />
// // //                   {formErrors.transaction_reference && (
// // //                     <span className="error-message">{formErrors.transaction_reference}</span>
// // //                   )}
// // //                 </div>

// // //                 <div className="form-group">
// // //                   <label htmlFor="notes">Notes (Optional)</label>
// // //                   <textarea
// // //                     id="notes"
// // //                     name="notes"
// // //                     value={formData.notes}
// // //                     onChange={handleInputChange}
// // //                     placeholder="Any additional notes..."
// // //                     rows="3"
// // //                     disabled={isSubmitting}
// // //                   />
// // //                 </div>

// // //                 <div className="modal-actions">
// // //                   <button
// // //                     type="button"
// // //                     className="btn btn-secondary"
// // //                     onClick={handleCloseDisbursementModal}
// // //                     disabled={isSubmitting}
// // //                   >
// // //                     Cancel
// // //                   </button>
// // //                   <button
// // //                     type="submit"
// // //                     className="btn btn-primary"
// // //                     disabled={isSubmitting}
// // //                   >
// // //                     {isSubmitting ? (
// // //                       <>
// // //                         <span className="spinner"></span>
// // //                         Processing...
// // //                       </>
// // //                     ) : (
// // //                       'Record Payment'
// // //                     )}
// // //                   </button>
// // //                 </div>
// // //               </form>
// // //             </div>
// // //           </div>
// // //         )}
// // //       </div>
// // //     </>
// // //   );
// // // };

// // // export default withAuth(PayoutsPage, 'admin');

// // // pages/PayoutsPage.jsx
// // import React, { useState, useEffect } from 'react';
// // import {
// //   FaSearch,
// //   FaMoneyBillWave,
// //   FaClock,
// //   FaCheckCircle,
// //   FaExclamationCircle,
// //   FaEye,
// //   FaPlus,
// //   FaTimes,
// //   FaUser,
// //   FaReceipt,
// //   FaProjectDiagram,
// //   FaWallet,
// //   FaBox,
// //   FaPhone,
// //   FaUniversity,
// // } from 'react-icons/fa';
// // import withAuth from '../../auth/WithAuth';
// // import { toast } from 'react-toastify';
// // import './disbursements.scss';
// // import { serverUrlAuth } from '../../../serverUrl';
// // import FurnitureNavbar from '../../../components/layout/Nav';

// // const PayoutsPage = () => {
// //   const [activeTab, setActiveTab] = useState('custom');
// //   const [payouts, setPayouts] = useState([]);
// //   const [readyMadeEarnings, setReadyMadeEarnings] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [showDisbursementModal, setShowDisbursementModal] = useState(false);
// //   const [showDetailModal, setShowDetailModal] = useState(false);
// //   const [selectedPayout, setSelectedPayout] = useState(null);
// //   const [selectedEarning, setSelectedEarning] = useState(null);
// //   const [detailData, setDetailData] = useState(null);
// //   const [detailLoading, setDetailLoading] = useState(false);
// //   const [isSubmitting, setIsSubmitting] = useState(false);
// //   const [formErrors, setFormErrors] = useState({});

// //   const [filters, setFilters] = useState({ status: 'all', search: '' });
// //   const [formData, setFormData] = useState({
// //     amount: '',
// //     payment_method: 'mpesa',
// //     transaction_reference: '',
// //     notes: '',
// //   });

// //   // Stats
// //   const [stats, setStats] = useState({
// //     total: 0,
// //     pending: 0,
// //     partially_paid: 0,
// //     paid: 0,
// //   });
// //   const [readyMadeStats, setReadyMadeStats] = useState({
// //     total: 0,
// //     pending: 0,
// //     partially_paid: 0,
// //     paid: 0,
// //   });

// //   // =============================================
// //   // FETCH FUNCTIONS
// //   // =============================================

// //   useEffect(() => {
// //     fetchPayouts();
// //     fetchReadyMadeEarnings();
// //   }, []);

// //   const fetchPayouts = async () => {
// //     setLoading(true);
// //     try {
// //       const url =
// //         filters.status !== 'all'
// //           ? `disbursement/payouts/?status=${filters.status}`
// //           : 'disbursement/payouts/';
// //       const response = await serverUrlAuth.get(url);
// //       const data = response.data;
// //       const payoutsData = Array.isArray(data) ? data : [];
// //       setPayouts(payoutsData);
// //       updateStats(payoutsData);
// //     } catch (error) {
// //       console.error('Error:', error);
// //       toast.error('Failed to load payouts');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const fetchReadyMadeEarnings = async () => {
// //     setLoading(true);
// //     try {
// //       const response = await serverUrlAuth.get(
// //         'disbursement/admin/ready-made-disbursements/',
// //       );
// //       const data = response.data;
// //       const earnings = data.earnings || [];
// //       setReadyMadeEarnings(earnings);
// //       updateReadyMadeStats(earnings);
// //     } catch (error) {
// //       console.error('Error:', error);
// //       toast.error('Failed to load ready-made earnings');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const fetchDetail = async (id, type) => {
// //     setDetailLoading(true);
// //     setDetailData(null);
// //     try {
// //       let response;
// //       if (type === 'custom') {
// //         response = await serverUrlAuth.get(`disbursement/payouts/${id}/`);
// //         setDetailData(response.data.payout || response.data);
// //       } else {
// //         response = await serverUrlAuth.get(
// //           `disbursement/admin/ready-made-earnings/${id}/`,
// //         );
// //         setDetailData(response.data.earning || response.data);
// //       }
// //     } catch (error) {
// //       console.error('Error:', error);
// //       toast.error('Failed to load details');
// //     } finally {
// //       setDetailLoading(false);
// //     }
// //   };

// //   const recordDisbursement = async (id, payload, type) => {
// //     let endpoint;
// //     if (type === 'custom') {
// //       endpoint = `disbursement/payouts/${id}/disburse/`;
// //     } else {
// //       endpoint = `disbursement/admin/ready-made-earnings/${id}/disburse/`;
// //     }
// //     const response = await serverUrlAuth.post(endpoint, payload);
// //     return response.data;
// //   };

// //   // =============================================
// //   // UI FUNCTIONS
// //   // =============================================

// //   const updateStats = (data) => {
// //     setStats({
// //       total: data.length,
// //       pending: data.filter((p) => p.status === 'pending').length,
// //       partially_paid: data.filter((p) => p.status === 'partially_paid').length,
// //       paid: data.filter((p) => p.status === 'paid').length,
// //     });
// //   };

// //   const updateReadyMadeStats = (data) => {
// //     setReadyMadeStats({
// //       total: data.length,
// //       pending: data.filter((e) => e.status === 'pending').length,
// //       partially_paid: data.filter((e) => e.status === 'partially_paid').length,
// //       paid: data.filter((e) => e.status === 'paid').length,
// //     });
// //   };

// //   const handleViewDetails = (item) => {
// //     if (activeTab === 'custom') {
// //       setSelectedPayout(item);
// //       fetchDetail(item.id, 'custom');
// //     } else {
// //       setSelectedEarning(item);
// //       fetchDetail(item.id, 'ready-made');
// //     }
// //     setShowDetailModal(true);
// //   };

// //   const handleOpenDisbursement = (item) => {
// //     if (activeTab === 'custom') {
// //       setSelectedPayout(item);
// //     } else {
// //       setSelectedEarning(item);
// //     }

// //     const remaining =
// //       activeTab === 'custom'
// //         ? parseFloat(item.amount_remaining) || 0
// //         : (parseFloat(item.net_amount) || 0) -
// //           (parseFloat(item.amount_disbursed) || 0);

// //     setFormData({
// //       amount: remaining > 0 ? remaining.toString() : '',
// //       payment_method: 'mpesa',
// //       transaction_reference: '',
// //       notes: '',
// //     });
// //     setFormErrors({});
// //     setShowDisbursementModal(true);
// //   };

// //   const handleCloseModals = () => {
// //     setShowDetailModal(false);
// //     setShowDisbursementModal(false);
// //     setSelectedPayout(null);
// //     setSelectedEarning(null);
// //     setDetailData(null);
// //     setFormData({
// //       amount: '',
// //       payment_method: 'mpesa',
// //       transaction_reference: '',
// //       notes: '',
// //     });
// //     setFormErrors({});
// //   };

// //   const handleInputChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData((prev) => ({ ...prev, [name]: value }));
// //     if (formErrors[name]) {
// //       setFormErrors((prev) => ({ ...prev, [name]: '' }));
// //     }
// //   };

// //   const validateForm = () => {
// //     const errors = {};
// //     const amount = parseFloat(formData.amount);

// //     let maxAmount = 0;
// //     if (activeTab === 'custom' && selectedPayout) {
// //       maxAmount = parseFloat(selectedPayout.amount_remaining) || 0;
// //     } else if (activeTab === 'ready-made' && selectedEarning) {
// //       maxAmount =
// //         (parseFloat(selectedEarning.net_amount) || 0) -
// //         (parseFloat(selectedEarning.amount_disbursed) || 0);
// //     }

// //     if (!formData.amount) errors.amount = 'Amount is required';
// //     else if (isNaN(amount) || amount <= 0)
// //       errors.amount = 'Amount must be greater than 0';
// //     else if (amount > maxAmount)
// //       errors.amount = `Amount exceeds remaining balance (${formatCurrency(maxAmount)})`;
// //     if (!formData.payment_method)
// //       errors.payment_method = 'Payment method is required';
// //     if (!formData.transaction_reference)
// //       errors.transaction_reference = 'Transaction reference is required';

// //     return errors;
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     const errors = validateForm();
// //     if (Object.keys(errors).length > 0) {
// //       setFormErrors(errors);
// //       return;
// //     }

// //     setIsSubmitting(true);
// //     try {
// //       const payload = {
// //         amount: parseFloat(formData.amount),
// //         payment_method: formData.payment_method,
// //         transaction_reference: formData.transaction_reference,
// //         notes: formData.notes,
// //       };

// //       let id;
// //       if (activeTab === 'custom' && selectedPayout) {
// //         id = selectedPayout.id;
// //       } else if (activeTab === 'ready-made' && selectedEarning) {
// //         id = selectedEarning.id;
// //       } else {
// //         toast.error('No item selected');
// //         return;
// //       }

// //       await recordDisbursement(id, payload, activeTab);
// //       toast.success('Disbursement recorded successfully!');

// //       if (activeTab === 'custom') {
// //         await fetchPayouts();
// //       } else {
// //         await fetchReadyMadeEarnings();
// //       }

// //       handleCloseModals();
// //     } catch (error) {
// //       console.error('Error:', error);
// //       toast.error(
// //         error.response?.data?.error || 'Failed to record disbursement',
// //       );
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   // =============================================
// //   // HELPERS
// //   // =============================================

// //   const getStatusConfig = (status) => {
// //     const configs = {
// //       pending: {
// //         label: 'Pending',
// //         icon: FaClock,
// //         className: 'status-pending',
// //         color: '#F59E0B',
// //         bg: '#FEF3C7',
// //       },
// //       partially_paid: {
// //         label: 'Partially Paid',
// //         icon: FaExclamationCircle,
// //         className: 'status-partial',
// //         color: '#3B82F6',
// //         bg: '#DBEAFE',
// //       },
// //       paid: {
// //         label: 'Paid',
// //         icon: FaCheckCircle,
// //         className: 'status-paid',
// //         color: '#10B981',
// //         bg: '#D1FAE5',
// //       },
// //       cancelled: {
// //         label: 'Cancelled',
// //         icon: FaExclamationCircle,
// //         className: 'status-cancelled',
// //         color: '#EF4444',
// //         bg: '#FEE2E2',
// //       },
// //     };
// //     return configs[status] || configs.pending;
// //   };

// //   const formatCurrency = (amount) => {
// //     if (amount === undefined || amount === null || isNaN(amount))
// //       return 'KES 0.00';
// //     return new Intl.NumberFormat('en-KE', {
// //       style: 'currency',
// //       currency: 'KES',
// //       minimumFractionDigits: 2,
// //     }).format(parseFloat(amount));
// //   };

// //   const formatDate = (date) => {
// //     if (!date) return 'N/A';
// //     try {
// //       return new Date(date).toLocaleDateString('en-KE', {
// //         year: 'numeric',
// //         month: 'short',
// //         day: 'numeric',
// //         hour: '2-digit',
// //         minute: '2-digit',
// //       });
// //     } catch {
// //       return 'N/A';
// //     }
// //   };

// //   // =============================================
// //   // RENDER FUNCTIONS
// //   // =============================================

// //   const renderStats = (statsData) => (
// //     <div className="stats-overview">
// //       {['total', 'pending', 'partially_paid', 'paid'].map((key) => (
// //         <div key={key} className={`stat-card ${key}`}>
// //           <div className="stat-icon">
// //             {key === 'total' && <FaMoneyBillWave />}
// //             {key === 'pending' && <FaClock />}
// //             {key === 'partially_paid' && <FaExclamationCircle />}
// //             {key === 'paid' && <FaCheckCircle />}
// //           </div>
// //           <div className="stat-info">
// //             <h3>
// //               {key === 'total'
// //                 ? 'Total'
// //                 : key === 'partially_paid'
// //                 ? 'Partially Paid'
// //                 : key.charAt(0).toUpperCase() + key.slice(1)}
// //             </h3>
// //             <p className="stat-value">{statsData[key]}</p>
// //           </div>
// //         </div>
// //       ))}
// //     </div>
// //   );

// //   // Render Payment Details Section
// //   const renderPaymentDetails = (paymentDetails) => {
// //     if (!paymentDetails) {
// //       return (
// //         <div className="payment-details-empty">
// //           <FaWallet className="empty-icon" />
// //           <p>No payment details available</p>
// //           <span className="empty-sub">
// //             Artisan hasn't set up payment method yet
// //           </span>
// //         </div>
// //       );
// //     }

// //     const isMpesa = paymentDetails.payment_method === 'mpesa';

// //     return (
// //       <div className="payment-details-grid">
// //         <div className="payment-method-badge">
// //           <span className={`method-badge ${isMpesa ? 'mpesa' : 'bank'}`}>
// //             {isMpesa ? (
// //               <>
// //                 <FaPhone className="method-icon" /> M-Pesa
// //               </>
// //             ) : (
// //               <>
// //                 <FaUniversity className="method-icon" /> Bank Transfer
// //               </>
// //             )}
// //           </span>
// //         </div>

// //         <div className="payment-details-list">
// //           {isMpesa ? (
// //             <>
// //               <div className="detail-item">
// //                 <span className="label">Phone Number</span>
// //                 <span className="value phone-number">
// //                   {paymentDetails.mpesa_phone_number || 'N/A'}
// //                 </span>
// //               </div>
// //               {paymentDetails.mpesa_name && (
// //                 <div className="detail-item">
// //                   <span className="label">Account Name</span>
// //                   <span className="value">{paymentDetails.mpesa_name}</span>
// //                 </div>
// //               )}
// //             </>
// //           ) : (
// //             <>
// //               <div className="detail-item">
// //                 <span className="label">Bank Name</span>
// //                 <span className="value bank-name">
// //                   {paymentDetails.bank_name || 'N/A'}
// //                 </span>
// //               </div>
// //               <div className="detail-item">
// //                 <span className="label">Account Name</span>
// //                 <span className="value">
// //                   {paymentDetails.bank_account_name || 'N/A'}
// //                 </span>
// //               </div>
// //               <div className="detail-item">
// //                 <span className="label">Account Number</span>
// //                 <span className="value account-number">
// //                   {paymentDetails.bank_account_number || 'N/A'}
// //                 </span>
// //               </div>
// //               {paymentDetails.bank_branch && (
// //                 <div className="detail-item">
// //                   <span className="label">Branch</span>
// //                   <span className="value">{paymentDetails.bank_branch}</span>
// //                 </div>
// //               )}
// //             </>
// //           )}
// //         </div>
// //       </div>
// //     );
// //   };

// //   // Custom Project Detail
// //   const renderCustomDetail = () => {
// //     if (detailLoading) {
// //       return (
// //         <div className="detail-loading">
// //           <div className="loading-spinner-small"></div>
// //           <p>Loading details...</p>
// //         </div>
// //       );
// //     }

// //     if (!detailData) {
// //       return (
// //         <div className="detail-error">
// //           <FaExclamationCircle className="error-icon" />
// //           <p>Failed to load details.</p>
// //         </div>
// //       );
// //     }

// //     const data = detailData;
// //     const statusConfig = getStatusConfig(data.status);
// //     const StatusIcon = statusConfig.icon;

// //     return (
// //       <div className="detail-content">
// //         {/* Header Card */}
// //         <div className="detail-header-card">
// //           <div className="header-left">
// //             <div className="payout-id">Payout #{data.id}</div>
// //             <div className="payout-title">{data.project_name || 'Custom Project'}</div>
// //           </div>
// //           <div className="header-right">
// //             <span className={`status-badge ${statusConfig.className}`}>
// //               <StatusIcon /> {statusConfig.label}
// //             </span>
// //           </div>
// //         </div>

// //         <div className="detail-two-column">
// //           <div className="detail-column-left">
// //             {/* Project Information */}
// //             <div className="detail-section">
// //               <div className="section-header">
// //                 <FaProjectDiagram className="section-icon" />
// //                 <h3 className="section-title">Project Information</h3>
// //               </div>
// //               <div className="detail-grid">
// //                 <div className="detail-item">
// //                   <span className="label">Project Name</span>
// //                   <span className="value">{data.project_name || 'N/A'}</span>
// //                 </div>
// //                 <div className="detail-item">
// //                   <span className="label">Project ID</span>
// //                   <span className="value">#{data.project_id || 'N/A'}</span>
// //                 </div>
// //                 <div className="detail-item">
// //                   <span className="label">Stage</span>
// //                   <span className="value stage-badge">
// //                     {data.payout_stage || 'N/A'}
// //                   </span>
// //                 </div>
// //                 <div className="detail-item">
// //                   <span className="label">Payment ID</span>
// //                   <span className="value">#{data.payment || 'N/A'}</span>
// //                 </div>
// //               </div>
// //             </div>

// //             {/* Artisan Information */}
// //             <div className="detail-section">
// //               <div className="section-header">
// //                 <FaUser className="section-icon" />
// //                 <h3 className="section-title">Artisan Information</h3>
// //               </div>
// //               <div className="detail-grid">
// //                 <div className="detail-item">
// //                   <span className="label">Name</span>
// //                   <span className="value">{data.artisan_name || 'N/A'}</span>
// //                 </div>
// //                 <div className="detail-item">
// //                   <span className="label">Artisan ID</span>
// //                   <span className="value">#{data.artisan || 'N/A'}</span>
// //                 </div>
// //                 <div className="detail-item">
// //                   <span className="label">Created</span>
// //                   <span className="value">{formatDate(data.created_at)}</span>
// //                 </div>
// //                 <div className="detail-item">
// //                   <span className="label">Updated</span>
// //                   <span className="value">{formatDate(data.updated_at)}</span>
// //                 </div>
// //               </div>
// //             </div>

// //             {/* Payment Details */}
// //             <div className="detail-section">
// //               <div className="section-header">
// //                 <FaWallet className="section-icon" />
// //                 <h3 className="section-title">Payment Details</h3>
// //               </div>
// //               {renderPaymentDetails(data.artisan_payment_details)}
// //             </div>
// //           </div>

// //           <div className="detail-column-right">
// //             {/* Financial Summary */}
// //             <div className="detail-section">
// //               <div className="section-header">
// //                 <FaMoneyBillWave className="section-icon" />
// //                 <h3 className="section-title">Financial Summary</h3>
// //               </div>
// //               <div className="financial-grid">
// //                 <div className="financial-item">
// //                   <span className="label">Gross Amount</span>
// //                   <span className="value">
// //                     {formatCurrency(data.gross_amount)}
// //                   </span>
// //                 </div>
// //                 <div className="financial-item">
// //                   <span className="label">Commission</span>
// //                   <span className="value text-muted">
// //                     {formatCurrency(data.commission_amount)}
// //                   </span>
// //                 </div>
// //                 <div className="financial-item highlight">
// //                   <span className="label">Artisan Amount</span>
// //                   <span className="value">
// //                     {formatCurrency(data.artisan_amount)}
// //                   </span>
// //                 </div>
// //                 <div className="financial-item">
// //                   <span className="label">Disbursed</span>
// //                   <span className="value text-success">
// //                     {formatCurrency(data.amount_disbursed)}
// //                   </span>
// //                 </div>
// //                 <div className="financial-item highlight-remaining">
// //                   <span className="label">Remaining</span>
// //                   <span className="value">
// //                     {formatCurrency(data.amount_remaining)}
// //                   </span>
// //                 </div>
// //               </div>
// //             </div>

// //             {/* Disbursement History */}
// //             {data.disbursements && data.disbursements.length > 0 && (
// //               <div className="detail-section">
// //                 <div className="section-header">
// //                   <FaReceipt className="section-icon" />
// //                   <h3 className="section-title">Disbursement History</h3>
// //                   <span className="disbursement-count">
// //                     {data.disbursements.length}
// //                   </span>
// //                 </div>
// //                 <div className="disbursement-list">
// //                   {data.disbursements.map((d, i) => (
// //                     <div key={d.id} className="disbursement-item">
// //                       <div className="disb-header">
// //                         <span className="disb-number">#{i + 1}</span>
// //                         <span className="disb-amount">
// //                           {formatCurrency(d.amount)}
// //                         </span>
// //                         <span className={`disb-method ${d.payment_method}`}>
// //                           {d.payment_method === 'mpesa'
// //                             ? '📱 M-Pesa'
// //                             : '🏦 Bank'}
// //                         </span>
// //                         <span className="disb-date">
// //                           {formatDate(d.disbursed_at)}
// //                         </span>
// //                       </div>
// //                       <div className="disb-body">
// //                         <div className="disb-reference">
// //                           <span className="ref-label">Reference:</span>
// //                           <span className="ref-value">
// //                             {d.transaction_reference}
// //                           </span>
// //                         </div>
// //                         {d.recorded_by_name && (
// //                           <div className="disb-recorded">
// //                             <span className="ref-label">Recorded by:</span>
// //                             <span className="ref-value">
// //                               {d.recorded_by_name}
// //                             </span>
// //                           </div>
// //                         )}
// //                       </div>
// //                       {d.notes && (
// //                         <div className="disb-notes">
// //                           <span className="notes-label">Notes:</span>
// //                           <span className="notes-value">{d.notes}</span>
// //                         </div>
// //                       )}
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //       </div>
// //     );
// //   };

// //   // Ready-Made Detail
// //   const renderReadyMadeDetail = () => {
// //     if (detailLoading) {
// //       return (
// //         <div className="detail-loading">
// //           <div className="loading-spinner-small"></div>
// //           <p>Loading details...</p>
// //         </div>
// //       );
// //     }

// //     if (!detailData) {
// //       return (
// //         <div className="detail-error">
// //           <FaExclamationCircle className="error-icon" />
// //           <p>Failed to load details.</p>
// //         </div>
// //       );
// //     }

// //     const data = detailData;
// //     const statusConfig = getStatusConfig(data.status || 'pending');
// //     const StatusIcon = statusConfig.icon;
// //     const paymentDetails = data.artisan_payment_details || data.payment_details;

// //     return (
// //       <div className="detail-content">
// //         {/* Header Card */}
// //         <div className="detail-header-card ready-made-header">
// //           <div className="header-left">
// //             <div className="payout-id">Earning #{data.id}</div>
// //             <div className="payout-title">Ready-Made Order</div>
// //           </div>
// //           <div className="header-right">
// //             <span className={`status-badge ${statusConfig.className}`}>
// //               <StatusIcon /> {statusConfig.label}
// //             </span>
// //           </div>
// //         </div>

// //         {/* Amount Summary */}
// //         <div className="amount-summary-card">
// //           <div className="amount-item">
// //             <span className="amount-label">Net Amount</span>
// //             <span className="amount-value net">
// //               {formatCurrency(data.net_amount)}
// //             </span>
// //           </div>
// //           <div className="amount-divider"></div>
// //           <div className="amount-item">
// //             <span className="amount-label">Disbursed</span>
// //             <span className="amount-value disbursed">
// //               {formatCurrency(data.amount_disbursed)}
// //             </span>
// //           </div>
// //           <div className="amount-divider"></div>
// //           <div className="amount-item">
// //             <span className="amount-label">Remaining</span>
// //             <span className="amount-value remaining">
// //               {formatCurrency(data.amount_remaining)}
// //             </span>
// //           </div>
// //         </div>

// //         <div className="detail-two-column">
// //           <div className="detail-column-left">
// //             {/* Artisan Information */}
// //             <div className="detail-section">
// //               <div className="section-header">
// //                 <FaUser className="section-icon" />
// //                 <h3 className="section-title">Artisan Information</h3>
// //               </div>
// //               <div className="detail-grid">
// //                 <div className="detail-item">
// //                   <span className="label">Name</span>
// //                   <span className="value">{data.artisan?.name || 'N/A'}</span>
// //                 </div>
// //                 <div className="detail-item">
// //                   <span className="label">Email</span>
// //                   <span className="value">{data.artisan?.email || 'N/A'}</span>
// //                 </div>
// //                 <div className="detail-item">
// //                   <span className="label">Artisan ID</span>
// //                   <span className="value">#{data.artisan?.id || 'N/A'}</span>
// //                 </div>
// //                 <div className="detail-item">
// //                   <span className="label">Status</span>
// //                   <span className={`status-badge ${statusConfig.className}`}>
// //                     <StatusIcon /> {statusConfig.label}
// //                   </span>
// //                 </div>
// //               </div>
// //             </div>

// //             {/* Payment Details */}
// //             <div className="detail-section">
// //               <div className="section-header">
// //                 <FaWallet className="section-icon" />
// //                 <h3 className="section-title">Payment Details</h3>
// //               </div>
// //               {renderPaymentDetails(paymentDetails)}
// //             </div>

// //             {/* Order Information */}
// //             <div className="detail-section">
// //               <div className="section-header">
// //                 <FaBox className="section-icon" />
// //                 <h3 className="section-title">Order Information</h3>
// //               </div>
// //               <div className="detail-grid">
// //                 <div className="detail-item">
// //                   <span className="label">Earning ID</span>
// //                   <span className="value">#{data.id}</span>
// //                 </div>
// //                 <div className="detail-item">
// //                   <span className="label">Artisan Order</span>
// //                   <span className="value">
// //                     #{data.artisan_order?.id || 'N/A'}
// //                   </span>
// //                 </div>
// //                 <div className="detail-item">
// //                   <span className="label">Customer Order</span>
// //                   <span className="value">
// //                     #{data.artisan_order?.customer_order_id || 'N/A'}
// //                   </span>
// //                 </div>
// //                 <div className="detail-item">
// //                   <span className="label">Created</span>
// //                   <span className="value">{formatDate(data.created_at)}</span>
// //                 </div>
// //                 {data.paid_at && (
// //                   <div className="detail-item full-width">
// //                     <span className="label">Paid At</span>
// //                     <span className="value">{formatDate(data.paid_at)}</span>
// //                   </div>
// //                 )}
// //               </div>
// //             </div>
// //           </div>

// //           <div className="detail-column-right">
// //             {/* Financial Breakdown */}
// //             <div className="detail-section">
// //               <div className="section-header">
// //                 <FaMoneyBillWave className="section-icon" />
// //                 <h3 className="section-title">Financial Breakdown</h3>
// //               </div>
// //               <div className="financial-breakdown">
// //                 <div className="breakdown-item">
// //                   <span className="breakdown-label">Gross Amount</span>
// //                   <span className="breakdown-value">
// //                     {formatCurrency(data.gross_amount)}
// //                   </span>
// //                 </div>
// //                 <div className="breakdown-item">
// //                   <span className="breakdown-label">Commission</span>
// //                   <span className="breakdown-value negative">
// //                     -{formatCurrency(data.commission_amount)}
// //                   </span>
// //                 </div>
// //                 <div className="breakdown-item total">
// //                   <span className="breakdown-label">Net Amount</span>
// //                   <span className="breakdown-value">
// //                     {formatCurrency(data.net_amount)}
// //                   </span>
// //                 </div>
// //               </div>
// //             </div>

// //             {/* Disbursement History */}
// //             {data.disbursements && data.disbursements.length > 0 && (
// //               <div className="detail-section">
// //                 <div className="section-header">
// //                   <FaReceipt className="section-icon" />
// //                   <h3 className="section-title">Disbursement History</h3>
// //                   <span className="disbursement-count">
// //                     {data.disbursements.length}
// //                   </span>
// //                 </div>
// //                 <div className="disbursement-list">
// //                   {data.disbursements.map((d, i) => (
// //                     <div key={d.id} className="disbursement-item">
// //                       <div className="disb-header">
// //                         <span className="disb-number">#{i + 1}</span>
// //                         <span className="disb-amount">
// //                           {formatCurrency(d.amount)}
// //                         </span>
// //                         <span className={`disb-method ${d.payment_method}`}>
// //                           {d.payment_method === 'mpesa'
// //                             ? '📱 M-Pesa'
// //                             : '🏦 Bank'}
// //                         </span>
// //                         <span className="disb-date">
// //                           {formatDate(d.disbursed_at)}
// //                         </span>
// //                       </div>
// //                       <div className="disb-body">
// //                         <div className="disb-reference">
// //                           <span className="ref-label">Reference:</span>
// //                           <span className="ref-value">
// //                             {d.transaction_reference}
// //                           </span>
// //                         </div>
// //                         {d.recorded_by_name && (
// //                           <div className="disb-recorded">
// //                             <span className="ref-label">Recorded by:</span>
// //                             <span className="ref-value">
// //                               {d.recorded_by_name}
// //                             </span>
// //                           </div>
// //                         )}
// //                       </div>
// //                       {d.notes && (
// //                         <div className="disb-notes">
// //                           <span className="notes-label">Notes:</span>
// //                           <span className="notes-value">{d.notes}</span>
// //                         </div>
// //                       )}
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //       </div>
// //     );
// //   };

// //   const renderTable = (data, type) => {
// //     if (data.length === 0) {
// //       return (
// //         <div className="empty-state">
// //           <div className="empty-icon">{type === 'custom' ? '💰' : '📦'}</div>
// //           <h3>No {type === 'custom' ? 'payouts' : 'earnings'} found</h3>
// //         </div>
// //       );
// //     }

// //     const isCustom = type === 'custom';

// //     return (
// //       <table className="payouts-table">
// //         <thead>
// //           <tr>
// //             {isCustom ? (
// //               <>
// //                 <th>Artisan</th>
// //                 <th>Project</th>
// //                 <th>Total</th>
// //                 <th>Disbursed</th>
// //                 <th>Remaining</th>
// //                 <th>Status</th>
// //                 <th>Date</th>
// //                 <th>Actions</th>
// //               </>
// //             ) : (
// //               <>
// //                 <th>ID</th>
// //                 <th>Artisan</th>
// //                 <th>Gross</th>
// //                 <th>Commission</th>
// //                 <th>Net</th>
// //                 <th>Disbursed</th>
// //                 <th>Remaining</th>
// //                 <th>Status</th>
// //                 <th>Date</th>
// //                 <th>Actions</th>
// //               </>
// //             )}
// //           </tr>
// //         </thead>
// //         <tbody>
// //           {data.map((item) => {
// //             const statusConfig = getStatusConfig(item.status || 'pending');
// //             const StatusIcon = statusConfig.icon;
// //             const isFullyPaid =
// //               item.status === 'paid' || item.status === 'cancelled';

// //             return (
// //               <tr key={item.id}>
// //                 {isCustom ? (
// //                   <>
// //                     <td>
// //                       <div className="artisan-info">
// //                         <div className="artisan-avatar">
// //                           {item.artisan_name?.charAt(0) || 'A'}
// //                         </div>
// //                         <div className="artisan-details">
// //                           <strong>
// //                             {item.artisan_name || `Artisan #${item.artisan}`}
// //                           </strong>
// //                         </div>
// //                       </div>
// //                     </td>
// //                     <td>
// //                       <strong>{item.project_name || 'N/A'}</strong>
// //                     </td>
// //                     <td className="amount-column">
// //                       {formatCurrency(item.gross_amount)}
// //                     </td>
// //                     <td className="amount-column">
// //                       {formatCurrency(item.amount_disbursed)}
// //                     </td>
// //                     <td className="amount-column">
// //                       <span
// //                         className={
// //                           parseFloat(item.amount_remaining) === 0 ? 'zero' : ''
// //                         }
// //                       >
// //                         {formatCurrency(item.amount_remaining)}
// //                       </span>
// //                     </td>
// //                   </>
// //                 ) : (
// //                   <>
// //                     <td>
// //                       <strong>#{item.id}</strong>
// //                     </td>
// //                     <td>
// //                       <div className="artisan-info">
// //                         <div className="artisan-avatar">
// //                           {item.artisan?.name?.charAt(0) || 'A'}
// //                         </div>
// //                         <div className="artisan-details">
// //                           <strong>{item.artisan?.name || 'N/A'}</strong>
// //                           <span>{item.artisan?.email || ''}</span>
// //                         </div>
// //                       </div>
// //                     </td>
// //                     <td className="amount-column">
// //                       {formatCurrency(item.gross_amount)}
// //                     </td>
// //                     <td className="amount-column">
// //                       {formatCurrency(item.commission_amount)}
// //                     </td>
// //                     <td className="amount-column">
// //                       <strong>{formatCurrency(item.net_amount)}</strong>
// //                     </td>
// //                     <td className="amount-column">
// //                       {formatCurrency(item.amount_disbursed)}
// //                     </td>
// //                     <td className="amount-column">
// //                       <span
// //                         className={
// //                           parseFloat(item.amount_remaining || 0) === 0
// //                             ? 'zero'
// //                             : ''
// //                         }
// //                       >
// //                         {formatCurrency(item.amount_remaining)}
// //                       </span>
// //                     </td>
// //                   </>
// //                 )}
// //                 <td>
// //                   <span className={`status-badge ${statusConfig.className}`}>
// //                     <StatusIcon /> {statusConfig.label}
// //                   </span>
// //                 </td>
// //                 <td>{formatDate(item.created_at)}</td>
// //                 <td>
// //                   <div className="action-buttons">
// //                     <button
// //                       className="btn btn-sm btn-view"
// //                       onClick={() => handleViewDetails(item)}
// //                     >
// //                       <FaEye /> View
// //                     </button>
// //                     {!isFullyPaid && (
// //                       <button
// //                         className="btn btn-sm btn-disburse"
// //                         onClick={() => handleOpenDisbursement(item)}
// //                       >
// //                         <FaPlus /> Pay
// //                       </button>
// //                     )}
// //                   </div>
// //                 </td>
// //               </tr>
// //             );
// //           })}
// //         </tbody>
// //       </table>
// //     );
// //   };

// //   // =============================================
// //   // MAIN RENDER
// //   // =============================================

// //   const filteredData =
// //     activeTab === 'custom'
// //       ? payouts.filter(
// //           (p) =>
// //             !filters.search ||
// //             p.artisan_name
// //               ?.toLowerCase()
// //               .includes(filters.search.toLowerCase()),
// //         )
// //       : readyMadeEarnings.filter(
// //           (e) =>
// //             !filters.search ||
// //             e.id?.toString().includes(filters.search) ||
// //             e.artisan?.name
// //               ?.toLowerCase()
// //               .includes(filters.search.toLowerCase()),
// //         );

// //   return (
// //     <>
// //       <FurnitureNavbar />
// //       <div className="payouts-page">
// //         <div className="page-header">
// //           <div className="header-content">
// //             <div className="header-text">
// //               <h1>💰 Payout Management</h1>
// //               <p>Manage artisan payouts and track disbursements</p>
// //             </div>
// //           </div>
// //         </div>

// //         <div className="tabs-container">
// //           <button
// //             className={`tab-btn ${activeTab === 'custom' ? 'active' : ''}`}
// //             onClick={() => setActiveTab('custom')}
// //           >
// //             <FaProjectDiagram /> Custom Projects
// //           </button>
// //           <button
// //             className={`tab-btn ${activeTab === 'ready-made' ? 'active' : ''}`}
// //             onClick={() => setActiveTab('ready-made')}
// //           >
// //             <FaBox /> Ready-Made Orders
// //           </button>
// //         </div>

// //         {renderStats(activeTab === 'custom' ? stats : readyMadeStats)}

// //         <div className="filters-section">
// //           <div className="filters-bar">
// //             <div className="search-box">
// //               <FaSearch className="search-icon" />
// //               <input
// //                 type="text"
// //                 placeholder={`Search ${activeTab === 'custom' ? 'artisan or project' : 'ID or artisan'}...`}
// //                 value={filters.search}
// //                 onChange={(e) =>
// //                   setFilters((prev) => ({ ...prev, search: e.target.value }))
// //                 }
// //               />
// //             </div>
// //             {activeTab === 'custom' && (
// //               <select
// //                 value={filters.status}
// //                 onChange={(e) =>
// //                   setFilters((prev) => ({ ...prev, status: e.target.value }))
// //                 }
// //               >
// //                 <option value="all">All Status</option>
// //                 <option value="pending">Pending</option>
// //                 <option value="partially_paid">Partially Paid</option>
// //                 <option value="paid">Paid</option>
// //               </select>
// //             )}
// //             <button
// //               className="btn btn-refresh"
// //               onClick={() => {
// //                 if (activeTab === 'custom') fetchPayouts();
// //                 else fetchReadyMadeEarnings();
// //               }}
// //             >
// //               🔄 Refresh
// //             </button>
// //           </div>
// //         </div>

// //         <div className="table-section">
// //           <div className="table-container">
// //             {loading ? (
// //               <div className="loading-container">
// //                 <div className="loading-spinner"></div>
// //                 <p>Loading...</p>
// //               </div>
// //             ) : (
// //               renderTable(filteredData, activeTab)
// //             )}
// //           </div>
// //         </div>

// //         {/* Detail Modal */}
// //         {showDetailModal && (
// //           <div className="modal-overlay" onClick={handleCloseModals}>
// //             <div
// //               className="modal-content detail-modal"
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div className="modal-header">
// //                 <div className="modal-title">
// //                   <h2>
// //                     {activeTab === 'custom'
// //                       ? `Payout #${selectedPayout?.id || ''}`
// //                       : `Earning #${selectedEarning?.id || ''}`}
// //                   </h2>
// //                 </div>
// //                 <button className="close-modal" onClick={handleCloseModals}>
// //                   <FaTimes />
// //                 </button>
// //               </div>

// //               <div className="modal-body">
// //                 {activeTab === 'custom'
// //                   ? renderCustomDetail()
// //                   : renderReadyMadeDetail()}
// //               </div>

// //               <div className="modal-footer">
// //                 <button
// //                   className="btn btn-secondary"
// //                   onClick={handleCloseModals}
// //                 >
// //                   Close
// //                 </button>
// //                 {activeTab === 'custom' &&
// //                   selectedPayout?.status !== 'paid' &&
// //                   selectedPayout?.status !== 'cancelled' && (
// //                     <button
// //                       className="btn btn-primary"
// //                       onClick={() => {
// //                         handleCloseModals();
// //                         handleOpenDisbursement(selectedPayout);
// //                       }}
// //                     >
// //                       <FaPlus /> Record Payment
// //                     </button>
// //                   )}
// //                 {activeTab === 'ready-made' &&
// //                   selectedEarning &&
// //                   selectedEarning.status !== 'paid' && (
// //                     <button
// //                       className="btn btn-primary"
// //                       onClick={() => {
// //                         handleCloseModals();
// //                         handleOpenDisbursement(selectedEarning);
// //                       }}
// //                     >
// //                       <FaPlus /> Record Payment
// //                     </button>
// //                   )}
// //               </div>
// //             </div>
// //           </div>
// //         )}

// //         {/* Disbursement Modal */}
// //         {showDisbursementModal && (
// //           <div className="modal-overlay" onClick={handleCloseModals}>
// //             <div className="modal-content" onClick={(e) => e.stopPropagation()}>
// //               <div className="modal-header">
// //                 <h2>Record Disbursement</h2>
// //                 <button className="close-modal" onClick={handleCloseModals}>
// //                   <FaTimes />
// //                 </button>
// //               </div>

// //               <form onSubmit={handleSubmit}>
// //                 <div className="form-group">
// //                   <label>Amount *</label>
// //                   <input
// //                     type="number"
// //                     name="amount"
// //                     value={formData.amount}
// //                     onChange={handleInputChange}
// //                     placeholder="Enter amount"
// //                     step="0.01"
// //                     min="0.01"
// //                     className={formErrors.amount ? 'error' : ''}
// //                     disabled={isSubmitting}
// //                   />
// //                   {formErrors.amount && (
// //                     <span className="error-message">{formErrors.amount}</span>
// //                   )}
// //                 </div>

// //                 <div className="form-group">
// //                   <label>Payment Method *</label>
// //                   <select
// //                     name="payment_method"
// //                     value={formData.payment_method}
// //                     onChange={handleInputChange}
// //                     className={formErrors.payment_method ? 'error' : ''}
// //                     disabled={isSubmitting}
// //                   >
// //                     <option value="mpesa">M-Pesa</option>
// //                     <option value="bank">Bank Transfer</option>
// //                   </select>
// //                   {formErrors.payment_method && (
// //                     <span className="error-message">
// //                       {formErrors.payment_method}
// //                     </span>
// //                   )}
// //                 </div>

// //                 <div className="form-group">
// //                   <label>Transaction Reference *</label>
// //                   <input
// //                     type="text"
// //                     name="transaction_reference"
// //                     value={formData.transaction_reference}
// //                     onChange={handleInputChange}
// //                     placeholder="Enter transaction reference"
// //                     className={formErrors.transaction_reference ? 'error' : ''}
// //                     disabled={isSubmitting}
// //                   />
// //                   {formErrors.transaction_reference && (
// //                     <span className="error-message">
// //                       {formErrors.transaction_reference}
// //                     </span>
// //                   )}
// //                 </div>

// //                 <div className="form-group">
// //                   <label>Notes (Optional)</label>
// //                   <textarea
// //                     name="notes"
// //                     value={formData.notes}
// //                     onChange={handleInputChange}
// //                     placeholder="Any notes..."
// //                     rows="2"
// //                     disabled={isSubmitting}
// //                   />
// //                 </div>

// //                 <div className="modal-actions">
// //                   <button
// //                     type="button"
// //                     className="btn btn-secondary"
// //                     onClick={handleCloseModals}
// //                     disabled={isSubmitting}
// //                   >
// //                     Cancel
// //                   </button>
// //                   <button
// //                     type="submit"
// //                     className="btn btn-primary"
// //                     disabled={isSubmitting}
// //                   >
// //                     {isSubmitting ? 'Processing...' : 'Record Payment'}
// //                   </button>
// //                 </div>
// //               </form>
// //             </div>
// //           </div>
// //         )}
// //       </div>
// //     </>
// //   );
// // };

// // export default withAuth(PayoutsPage, 'admin');

// // pages/PayoutsPage.jsx
// import React, { useState, useEffect } from 'react';
// import {
//   FaSearch,
//   FaMoneyBillWave,
//   FaClock,
//   FaCheckCircle,
//   FaExclamationCircle,
//   FaEye,
//   FaPlus,
//   FaTimes,
//   FaUser,
//   FaReceipt,
//   FaProjectDiagram,
//   FaWallet,
//   FaBox,
//   FaPhone,
//   FaUniversity,
// } from 'react-icons/fa';
// import withAuth from '../../auth/WithAuth';
// import { toast } from 'react-toastify';
// import './disbursements.scss';
// import { serverUrlAuth } from '../../../serverUrl';
// import FurnitureNavbar from '../../../components/layout/Nav';

// const PayoutsPage = () => {
//   const [activeTab, setActiveTab] = useState('custom');
//   const [payouts, setPayouts] = useState([]);
//   const [readyMadeEarnings, setReadyMadeEarnings] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showDisbursementModal, setShowDisbursementModal] = useState(false);
//   const [showDetailModal, setShowDetailModal] = useState(false);
//   const [selectedPayout, setSelectedPayout] = useState(null);
//   const [selectedEarning, setSelectedEarning] = useState(null);
//   const [detailData, setDetailData] = useState(null);
//   const [detailLoading, setDetailLoading] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [formErrors, setFormErrors] = useState({});

//   const [filters, setFilters] = useState({ status: 'all', search: '' });
//   const [formData, setFormData] = useState({
//     amount: '',
//     payment_method: 'mpesa',
//     transaction_reference: '',
//     notes: '',
//   });

//   // Stats
//   const [stats, setStats] = useState({
//     total: 0,
//     pending: 0,
//     partially_paid: 0,
//     paid: 0,
//   });
//   const [readyMadeStats, setReadyMadeStats] = useState({
//     total: 0,
//     pending: 0,
//     partially_paid: 0,
//     paid: 0,
//   });

//   // =============================================
//   // FETCH FUNCTIONS
//   // =============================================

//   useEffect(() => {
//     fetchPayouts();
//     fetchReadyMadeEarnings();
//   }, []);

//   const fetchPayouts = async () => {
//     setLoading(true);
//     try {
//       const url =
//         filters.status !== 'all'
//           ? `disbursement/payouts/?status=${filters.status}`
//           : 'disbursement/payouts/';
//       const response = await serverUrlAuth.get(url);
//       const data = response.data;
//       const payoutsData = Array.isArray(data) ? data : [];
//       setPayouts(payoutsData);
//       updateStats(payoutsData);
//     } catch (error) {
//       console.error('Error:', error);
//       toast.error('Failed to load payouts');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchReadyMadeEarnings = async () => {
//     setLoading(true);
//     try {
//       const response = await serverUrlAuth.get(
//         'disbursement/admin/ready-made-disbursements/',
//       );
//       const data = response.data;
//       const earnings = data.earnings || [];
//       setReadyMadeEarnings(earnings);
//       updateReadyMadeStats(earnings);
//     } catch (error) {
//       console.error('Error:', error);
//       toast.error('Failed to load ready-made earnings');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchDetail = async (id, type) => {
//     setDetailLoading(true);
//     setDetailData(null);
//     try {
//       let response;
//       if (type === 'custom') {
//         response = await serverUrlAuth.get(`disbursement/payouts/${id}/`);
//         const data = response.data;
//         // Merge payout and disbursements into one object
//         setDetailData({
//           ...data.payout,
//           disbursements: data.disbursements || [],
//         });
//       } else {
//         response = await serverUrlAuth.get(
//           `disbursement/admin/ready-made-earnings/${id}/`,
//         );
//         const data = response.data;
//         setDetailData(data.earning || data);
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       toast.error('Failed to load details');
//     } finally {
//       setDetailLoading(false);
//     }
//   };

//   const recordDisbursement = async (id, payload, type) => {
//     let endpoint;
//     if (type === 'custom') {
//       endpoint = `disbursement/payouts/${id}/disburse/`;
//     } else {
//       endpoint = `disbursement/admin/ready-made-earnings/${id}/disburse/`;
//     }
//     const response = await serverUrlAuth.post(endpoint, payload);
//     return response.data;
//   };

//   // =============================================
//   // UI FUNCTIONS
//   // =============================================

//   const updateStats = (data) => {
//     setStats({
//       total: data.length,
//       pending: data.filter((p) => p.status === 'pending').length,
//       partially_paid: data.filter((p) => p.status === 'partially_paid').length,
//       paid: data.filter((p) => p.status === 'paid').length,
//     });
//   };

//   const updateReadyMadeStats = (data) => {
//     setReadyMadeStats({
//       total: data.length,
//       pending: data.filter((e) => e.status === 'pending').length,
//       partially_paid: data.filter((e) => e.status === 'partially_paid').length,
//       paid: data.filter((e) => e.status === 'paid').length,
//     });
//   };

//   const handleViewDetails = (item) => {
//     if (activeTab === 'custom') {
//       setSelectedPayout(item);
//       fetchDetail(item.id, 'custom');
//     } else {
//       setSelectedEarning(item);
//       fetchDetail(item.id, 'ready-made');
//     }
//     setShowDetailModal(true);
//   };

//   const handleOpenDisbursement = (item) => {
//     if (activeTab === 'custom') {
//       setSelectedPayout(item);
//     } else {
//       setSelectedEarning(item);
//     }

//     const remaining =
//       activeTab === 'custom'
//         ? parseFloat(item.amount_remaining) || 0
//         : (parseFloat(item.net_amount) || 0) -
//           (parseFloat(item.amount_disbursed) || 0);

//     setFormData({
//       amount: remaining > 0 ? remaining.toString() : '',
//       payment_method: 'mpesa',
//       transaction_reference: '',
//       notes: '',
//     });
//     setFormErrors({});
//     setShowDisbursementModal(true);
//   };

//   const handleCloseModals = () => {
//     setShowDetailModal(false);
//     setShowDisbursementModal(false);
//     setSelectedPayout(null);
//     setSelectedEarning(null);
//     setDetailData(null);
//     setFormData({
//       amount: '',
//       payment_method: 'mpesa',
//       transaction_reference: '',
//       notes: '',
//     });
//     setFormErrors({});
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     if (formErrors[name]) {
//       setFormErrors((prev) => ({ ...prev, [name]: '' }));
//     }
//   };

//   const validateForm = () => {
//     const errors = {};
//     const amount = parseFloat(formData.amount);

//     let maxAmount = 0;
//     if (activeTab === 'custom' && selectedPayout) {
//       maxAmount = parseFloat(selectedPayout.amount_remaining) || 0;
//     } else if (activeTab === 'ready-made' && selectedEarning) {
//       maxAmount =
//         (parseFloat(selectedEarning.net_amount) || 0) -
//         (parseFloat(selectedEarning.amount_disbursed) || 0);
//     }

//     if (!formData.amount) errors.amount = 'Amount is required';
//     else if (isNaN(amount) || amount <= 0)
//       errors.amount = 'Amount must be greater than 0';
//     else if (amount > maxAmount)
//       errors.amount = `Amount exceeds remaining balance (${formatCurrency(maxAmount)})`;
//     if (!formData.payment_method)
//       errors.payment_method = 'Payment method is required';
//     if (!formData.transaction_reference)
//       errors.transaction_reference = 'Transaction reference is required';

//     return errors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const errors = validateForm();
//     if (Object.keys(errors).length > 0) {
//       setFormErrors(errors);
//       return;
//     }

//     setIsSubmitting(true);
//     try {
//       const payload = {
//         amount: parseFloat(formData.amount),
//         payment_method: formData.payment_method,
//         transaction_reference: formData.transaction_reference,
//         notes: formData.notes,
//       };

//       let id;
//       if (activeTab === 'custom' && selectedPayout) {
//         id = selectedPayout.id;
//       } else if (activeTab === 'ready-made' && selectedEarning) {
//         id = selectedEarning.id;
//       } else {
//         toast.error('No item selected');
//         return;
//       }

//       await recordDisbursement(id, payload, activeTab);
//       toast.success('Disbursement recorded successfully!');

//       if (activeTab === 'custom') {
//         await fetchPayouts();
//       } else {
//         await fetchReadyMadeEarnings();
//       }

//       handleCloseModals();
//     } catch (error) {
//       console.error('Error:', error);
//       toast.error(
//         error.response?.data?.error || 'Failed to record disbursement',
//       );
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // =============================================
//   // HELPERS
//   // =============================================

//   const getStatusConfig = (status) => {
//     const configs = {
//       pending: {
//         label: 'Pending',
//         icon: FaClock,
//         className: 'status-pending',
//         color: '#F59E0B',
//         bg: '#FEF3C7',
//       },
//       partially_paid: {
//         label: 'Partially Paid',
//         icon: FaExclamationCircle,
//         className: 'status-partial',
//         color: '#3B82F6',
//         bg: '#DBEAFE',
//       },
//       paid: {
//         label: 'Paid',
//         icon: FaCheckCircle,
//         className: 'status-paid',
//         color: '#10B981',
//         bg: '#D1FAE5',
//       },
//       cancelled: {
//         label: 'Cancelled',
//         icon: FaExclamationCircle,
//         className: 'status-cancelled',
//         color: '#EF4444',
//         bg: '#FEE2E2',
//       },
//     };
//     return configs[status] || configs.pending;
//   };

//   const formatCurrency = (amount) => {
//     if (amount === undefined || amount === null || isNaN(amount))
//       return 'KES 0.00';
//     return new Intl.NumberFormat('en-KE', {
//       style: 'currency',
//       currency: 'KES',
//       minimumFractionDigits: 2,
//     }).format(parseFloat(amount));
//   };

//   const formatDate = (date) => {
//     if (!date) return 'N/A';
//     try {
//       return new Date(date).toLocaleDateString('en-KE', {
//         year: 'numeric',
//         month: 'short',
//         day: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit',
//       });
//     } catch {
//       return 'N/A';
//     }
//   };

//   // =============================================
//   // RENDER FUNCTIONS
//   // =============================================

//   const renderStats = (statsData) => (
//     <div className="stats-overview">
//       {['total', 'pending', 'partially_paid', 'paid'].map((key) => (
//         <div key={key} className={`stat-card ${key}`}>
//           <div className="stat-icon">
//             {key === 'total' && <FaMoneyBillWave />}
//             {key === 'pending' && <FaClock />}
//             {key === 'partially_paid' && <FaExclamationCircle />}
//             {key === 'paid' && <FaCheckCircle />}
//           </div>
//           <div className="stat-info">
//             <h3>
//               {key === 'total'
//                 ? 'Total'
//                 : key === 'partially_paid'
//                 ? 'Partially Paid'
//                 : key.charAt(0).toUpperCase() + key.slice(1)}
//             </h3>
//             <p className="stat-value">{statsData[key]}</p>
//           </div>
//         </div>
//       ))}
//     </div>
//   );

//   // Render Payment Details Section
//   const renderPaymentDetails = (paymentDetails) => {
//     if (!paymentDetails) {
//       return (
//         <div className="payment-details-empty">
//           <FaWallet className="empty-icon" />
//           <p>No payment details available</p>
//           <span className="empty-sub">
//             Artisan hasn't set up payment method yet
//           </span>
//         </div>
//       );
//     }

//     const isMpesa = paymentDetails.payment_method === 'mpesa';

//     return (
//       <div className="payment-details-grid">
//         <div className="payment-method-badge">
//           <span className={`method-badge ${isMpesa ? 'mpesa' : 'bank'}`}>
//             {isMpesa ? (
//               <>
//                 <FaPhone className="method-icon" /> M-Pesa
//               </>
//             ) : (
//               <>
//                 <FaUniversity className="method-icon" /> Bank Transfer
//               </>
//             )}
//           </span>
//         </div>

//         <div className="payment-details-list">
//           {isMpesa ? (
//             <>
//               <div className="detail-item">
//                 <span className="label">Phone Number</span>
//                 <span className="value phone-number">
//                   {paymentDetails.mpesa_phone_number || 'N/A'}
//                 </span>
//               </div>
//               {paymentDetails.mpesa_name && (
//                 <div className="detail-item">
//                   <span className="label">Account Name</span>
//                   <span className="value">{paymentDetails.mpesa_name}</span>
//                 </div>
//               )}
//             </>
//           ) : (
//             <>
//               <div className="detail-item">
//                 <span className="label">Bank Name</span>
//                 <span className="value bank-name">
//                   {paymentDetails.bank_name || 'N/A'}
//                 </span>
//               </div>
//               <div className="detail-item">
//                 <span className="label">Account Name</span>
//                 <span className="value">
//                   {paymentDetails.bank_account_name || 'N/A'}
//                 </span>
//               </div>
//               <div className="detail-item">
//                 <span className="label">Account Number</span>
//                 <span className="value account-number">
//                   {paymentDetails.bank_account_number || 'N/A'}
//                 </span>
//               </div>
//               {paymentDetails.bank_branch && (
//                 <div className="detail-item">
//                   <span className="label">Branch</span>
//                   <span className="value">{paymentDetails.bank_branch}</span>
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </div>
//     );
//   };

//   // Render Disbursement History (shared between custom and ready-made)
//   const renderDisbursementHistory = (disbursements) => {
//     if (!disbursements || disbursements.length === 0) {
//       return (
//         <div className="no-disbursements">
//           <p>No disbursements recorded yet.</p>
//         </div>
//       );
//     }

//     return (
//       <div className="disbursement-list">
//         {disbursements.map((d, i) => (
//           <div key={d.id || i} className="disbursement-item">
//             <div className="disb-header">
//               <span className="disb-number">#{i + 1}</span>
//               <span className="disb-amount">
//                 {formatCurrency(d.amount)}
//               </span>
//               <span className={`disb-method ${d.payment_method || 'mpesa'}`}>
//                 {d.payment_method === 'mpesa' ? '📱 M-Pesa' : '🏦 Bank Transfer'}
//               </span>
//               <span className="disb-date">
//                 {formatDate(d.disbursed_at)}
//               </span>
//             </div>
//             <div className="disb-body">
//               <div className="disb-reference">
//                 <span className="ref-label">Reference:</span>
//                 <span className="ref-value">
//                   {d.transaction_reference || 'N/A'}
//                 </span>
//               </div>
//               {d.recorded_by_name && (
//                 <div className="disb-recorded">
//                   <span className="ref-label">Recorded by:</span>
//                   <span className="ref-value">
//                     {d.recorded_by_name}
//                   </span>
//                 </div>
//               )}
//               {/* Show project info if available */}
//               {d.project_name && (
//                 <div className="disb-project">
//                   <span className="ref-label">Project:</span>
//                   <span className="ref-value">
//                     {d.project_name}
//                   </span>
//                 </div>
//               )}
//               {d.payout_stage && (
//                 <div className="disb-stage">
//                   <span className="ref-label">Stage:</span>
//                   <span className="ref-value">
//                     {d.payout_stage}
//                   </span>
//                 </div>
//               )}
//             </div>
//             {d.notes && (
//               <div className="disb-notes">
//                 <span className="notes-label">Notes:</span>
//                 <span className="notes-value">{d.notes}</span>
//               </div>
//             )}
//           </div>
//         ))}
//       </div>
//     );
//   };

//   // Custom Project Detail
//   const renderCustomDetail = () => {
//     if (detailLoading) {
//       return (
//         <div className="detail-loading">
//           <div className="loading-spinner-small"></div>
//           <p>Loading details...</p>
//         </div>
//       );
//     }

//     if (!detailData) {
//       return (
//         <div className="detail-error">
//           <FaExclamationCircle className="error-icon" />
//           <p>Failed to load details.</p>
//         </div>
//       );
//     }

//     const data = detailData;
//     const statusConfig = getStatusConfig(data.status);
//     const StatusIcon = statusConfig.icon;

//     console.log('Custom detail data:', data);
//     console.log('Disbursements count:', data.disbursements?.length || 0);

//     return (
//       <div className="detail-content">
//         {/* Header Card */}
//         <div className="detail-header-card">
//           <div className="header-left">
//             <div className="payout-id">Payout #{data.id}</div>
//             <div className="payout-title">{data.project_name || 'Custom Project'}</div>
//           </div>
//           <div className="header-right">
//             <span className={`status-badge ${statusConfig.className}`}>
//               <StatusIcon /> {statusConfig.label}
//             </span>
//           </div>
//         </div>

//         <div className="detail-two-column">
//           <div className="detail-column-left">
//             {/* Project Information */}
//             <div className="detail-section">
//               <div className="section-header">
//                 <FaProjectDiagram className="section-icon" />
//                 <h3 className="section-title">Project Information</h3>
//               </div>
//               <div className="detail-grid">
//                 <div className="detail-item">
//                   <span className="label">Project Name</span>
//                   <span className="value">{data.project_name || 'N/A'}</span>
//                 </div>
//                 <div className="detail-item">
//                   <span className="label">Project ID</span>
//                   <span className="value">#{data.project_id || 'N/A'}</span>
//                 </div>
//                 <div className="detail-item">
//                   <span className="label">Stage</span>
//                   <span className="value stage-badge">
//                     {data.payout_stage || 'N/A'}
//                   </span>
//                 </div>
//                 <div className="detail-item">
//                   <span className="label">Payment ID</span>
//                   <span className="value">#{data.payment || 'N/A'}</span>
//                 </div>
//               </div>
//             </div>

//             {/* Artisan Information */}
//             <div className="detail-section">
//               <div className="section-header">
//                 <FaUser className="section-icon" />
//                 <h3 className="section-title">Artisan Information</h3>
//               </div>
//               <div className="detail-grid">
//                 <div className="detail-item">
//                   <span className="label">Name</span>
//                   <span className="value">{data.artisan_name || 'N/A'}</span>
//                 </div>
//                 <div className="detail-item">
//                   <span className="label">Artisan ID</span>
//                   <span className="value">#{data.artisan || 'N/A'}</span>
//                 </div>
//                 <div className="detail-item">
//                   <span className="label">Created</span>
//                   <span className="value">{formatDate(data.created_at)}</span>
//                 </div>
//                 <div className="detail-item">
//                   <span className="label">Updated</span>
//                   <span className="value">{formatDate(data.updated_at)}</span>
//                 </div>
//               </div>
//             </div>

//             {/* Payment Details */}
//             <div className="detail-section">
//               <div className="section-header">
//                 <FaWallet className="section-icon" />
//                 <h3 className="section-title">Payment Details</h3>
//               </div>
//               {renderPaymentDetails(data.artisan_payment_details)}
//             </div>
//           </div>

//           <div className="detail-column-right">
//             {/* Financial Summary */}
//             <div className="detail-section">
//               <div className="section-header">
//                 <FaMoneyBillWave className="section-icon" />
//                 <h3 className="section-title">Financial Summary</h3>
//               </div>
//               <div className="financial-grid">
//                 <div className="financial-item">
//                   <span className="label">Gross Amount</span>
//                   <span className="value">
//                     {formatCurrency(data.gross_amount)}
//                   </span>
//                 </div>
//                 <div className="financial-item">
//                   <span className="label">Commission</span>
//                   <span className="value text-muted">
//                     {formatCurrency(data.commission_amount)}
//                   </span>
//                 </div>
//                 <div className="financial-item highlight">
//                   <span className="label">Artisan Amount</span>
//                   <span className="value">
//                     {formatCurrency(data.artisan_amount)}
//                   </span>
//                 </div>
//                 <div className="financial-item">
//                   <span className="label">Disbursed</span>
//                   <span className="value text-success">
//                     {formatCurrency(data.amount_disbursed)}
//                   </span>
//                 </div>
//                 <div className="financial-item highlight-remaining">
//                   <span className="label">Remaining</span>
//                   <span className="value">
//                     {formatCurrency(data.amount_remaining)}
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* Disbursement History */}
//             <div className="detail-section">
//               <div className="section-header">
//                 <FaReceipt className="section-icon" />
//                 <h3 className="section-title">Disbursement History</h3>
//                 {data.disbursements && data.disbursements.length > 0 && (
//                   <span className="disbursement-count">
//                     {data.disbursements.length}
//                   </span>
//                 )}
//               </div>
//               {renderDisbursementHistory(data.disbursements)}
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // Ready-Made Detail
//   const renderReadyMadeDetail = () => {
//     if (detailLoading) {
//       return (
//         <div className="detail-loading">
//           <div className="loading-spinner-small"></div>
//           <p>Loading details...</p>
//         </div>
//       );
//     }

//     if (!detailData) {
//       return (
//         <div className="detail-error">
//           <FaExclamationCircle className="error-icon" />
//           <p>Failed to load details.</p>
//         </div>
//       );
//     }

//     const data = detailData;
//     const statusConfig = getStatusConfig(data.status || 'pending');
//     const StatusIcon = statusConfig.icon;
//     const paymentDetails = data.artisan_payment_details || data.payment_details;

//     return (
//       <div className="detail-content">
//         {/* Header Card */}
//         <div className="detail-header-card ready-made-header">
//           <div className="header-left">
//             <div className="payout-id">Earning #{data.id}</div>
//             <div className="payout-title">Ready-Made Order</div>
//           </div>
//           <div className="header-right">
//             <span className={`status-badge ${statusConfig.className}`}>
//               <StatusIcon /> {statusConfig.label}
//             </span>
//           </div>
//         </div>

//         {/* Amount Summary Card */}
//         <div className="amount-summary-card">
//           <div className="amount-item">
//             <span className="amount-label">Net Amount</span>
//             <span className="amount-value net">
//               {formatCurrency(data.net_amount)}
//             </span>
//           </div>
//           <div className="amount-divider"></div>
//           <div className="amount-item">
//             <span className="amount-label">Disbursed</span>
//             <span className="amount-value disbursed">
//               {formatCurrency(data.amount_disbursed)}
//             </span>
//           </div>
//           <div className="amount-divider"></div>
//           <div className="amount-item">
//             <span className="amount-label">Remaining</span>
//             <span className="amount-value remaining">
//               {formatCurrency(data.amount_remaining)}
//             </span>
//           </div>
//         </div>

//         <div className="detail-two-column">
//           <div className="detail-column-left">
//             {/* Artisan Information */}
//             <div className="detail-section">
//               <div className="section-header">
//                 <FaUser className="section-icon" />
//                 <h3 className="section-title">Artisan Information</h3>
//               </div>
//               <div className="detail-grid">
//                 <div className="detail-item">
//                   <span className="label">Name</span>
//                   <span className="value">{data.artisan?.name || 'N/A'}</span>
//                 </div>
//                 <div className="detail-item">
//                   <span className="label">Email</span>
//                   <span className="value">{data.artisan?.email || 'N/A'}</span>
//                 </div>
//                 <div className="detail-item">
//                   <span className="label">Artisan ID</span>
//                   <span className="value">#{data.artisan?.id || 'N/A'}</span>
//                 </div>
//                 <div className="detail-item">
//                   <span className="label">Status</span>
//                   <span className={`status-badge ${statusConfig.className}`}>
//                     <StatusIcon /> {statusConfig.label}
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* Payment Details */}
//             <div className="detail-section">
//               <div className="section-header">
//                 <FaWallet className="section-icon" />
//                 <h3 className="section-title">Payment Details</h3>
//               </div>
//               {renderPaymentDetails(paymentDetails)}
//             </div>

//             {/* Order Information */}
//             <div className="detail-section">
//               <div className="section-header">
//                 <FaBox className="section-icon" />
//                 <h3 className="section-title">Order Information</h3>
//               </div>
//               <div className="detail-grid">
//                 <div className="detail-item">
//                   <span className="label">Earning ID</span>
//                   <span className="value">#{data.id}</span>
//                 </div>
//                 <div className="detail-item">
//                   <span className="label">Artisan Order</span>
//                   <span className="value">
//                     #{data.artisan_order?.id || 'N/A'}
//                   </span>
//                 </div>
//                 <div className="detail-item">
//                   <span className="label">Customer Order</span>
//                   <span className="value">
//                     #{data.artisan_order?.customer_order_id || 'N/A'}
//                   </span>
//                 </div>
//                 <div className="detail-item">
//                   <span className="label">Created</span>
//                   <span className="value">{formatDate(data.created_at)}</span>
//                 </div>
//                 {data.paid_at && (
//                   <div className="detail-item full-width">
//                     <span className="label">Paid At</span>
//                     <span className="value">{formatDate(data.paid_at)}</span>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           <div className="detail-column-right">
//             {/* Financial Breakdown */}
//             <div className="detail-section">
//               <div className="section-header">
//                 <FaMoneyBillWave className="section-icon" />
//                 <h3 className="section-title">Financial Breakdown</h3>
//               </div>
//               <div className="financial-breakdown">
//                 <div className="breakdown-item">
//                   <span className="breakdown-label">Gross Amount</span>
//                   <span className="breakdown-value">
//                     {formatCurrency(data.gross_amount)}
//                   </span>
//                 </div>
//                 <div className="breakdown-item">
//                   <span className="breakdown-label">Commission</span>
//                   <span className="breakdown-value negative">
//                     -{formatCurrency(data.commission_amount)}
//                   </span>
//                 </div>
//                 <div className="breakdown-item total">
//                   <span className="breakdown-label">Net Amount</span>
//                   <span className="breakdown-value">
//                     {formatCurrency(data.net_amount)}
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* Disbursement History */}
//             <div className="detail-section">
//               <div className="section-header">
//                 <FaReceipt className="section-icon" />
//                 <h3 className="section-title">Disbursement History</h3>
//                 {data.disbursements && data.disbursements.length > 0 && (
//                   <span className="disbursement-count">
//                     {data.disbursements.length}
//                   </span>
//                 )}
//               </div>
//               {renderDisbursementHistory(data.disbursements)}
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderTable = (data, type) => {
//     if (data.length === 0) {
//       return (
//         <div className="empty-state">
//           <div className="empty-icon">{type === 'custom' ? '💰' : '📦'}</div>
//           <h3>No {type === 'custom' ? 'payouts' : 'earnings'} found</h3>
//         </div>
//       );
//     }

//     const isCustom = type === 'custom';

//     return (
//       <table className="payouts-table">
//         <thead>
//           <tr>
//             {isCustom ? (
//               <>
//                 <th>Artisan</th>
//                 <th>Project</th>
//                 <th>Total</th>
//                 <th>Disbursed</th>
//                 <th>Remaining</th>
//                 <th>Status</th>
//                 <th>Date</th>
//                 <th>Actions</th>
//               </>
//             ) : (
//               <>
//                 <th>ID</th>
//                 <th>Artisan</th>
//                 <th>Gross</th>
//                 <th>Commission</th>
//                 <th>Net</th>
//                 <th>Disbursed</th>
//                 <th>Remaining</th>
//                 <th>Status</th>
//                 <th>Date</th>
//                 <th>Actions</th>
//               </>
//             )}
//           </tr>
//         </thead>
//         <tbody>
//           {data.map((item) => {
//             const statusConfig = getStatusConfig(item.status || 'pending');
//             const StatusIcon = statusConfig.icon;
//             const isFullyPaid =
//               item.status === 'paid' || item.status === 'cancelled';

//             return (
//               <tr key={item.id}>
//                 {isCustom ? (
//                   <>
//                     <td>
//                       <div className="artisan-info">
//                         <div className="artisan-avatar">
//                           {item.artisan_name?.charAt(0) || 'A'}
//                         </div>
//                         <div className="artisan-details">
//                           <strong>
//                             {item.artisan_name || `Artisan #${item.artisan}`}
//                           </strong>
//                         </div>
//                       </div>
//                     </td>
//                     <td>
//                       <strong>{item.project_name || 'N/A'}</strong>
//                     </td>
//                     <td className="amount-column">
//                       {formatCurrency(item.gross_amount)}
//                     </td>
//                     <td className="amount-column">
//                       {formatCurrency(item.amount_disbursed)}
//                     </td>
//                     <td className="amount-column">
//                       <span
//                         className={
//                           parseFloat(item.amount_remaining) === 0 ? 'zero' : ''
//                         }
//                       >
//                         {formatCurrency(item.amount_remaining)}
//                       </span>
//                     </td>
//                   </>
//                 ) : (
//                   <>
//                     <td>
//                       <strong>#{item.id}</strong>
//                     </td>
//                     <td>
//                       <div className="artisan-info">
//                         <div className="artisan-avatar">
//                           {item.artisan?.name?.charAt(0) || 'A'}
//                         </div>
//                         <div className="artisan-details">
//                           <strong>{item.artisan?.name || 'N/A'}</strong>
//                           <span>{item.artisan?.email || ''}</span>
//                         </div>
//                       </div>
//                     </td>
//                     <td className="amount-column">
//                       {formatCurrency(item.gross_amount)}
//                     </td>
//                     <td className="amount-column">
//                       {formatCurrency(item.commission_amount)}
//                     </td>
//                     <td className="amount-column">
//                       <strong>{formatCurrency(item.net_amount)}</strong>
//                     </td>
//                     <td className="amount-column">
//                       {formatCurrency(item.amount_disbursed)}
//                     </td>
//                     <td className="amount-column">
//                       <span
//                         className={
//                           parseFloat(item.amount_remaining || 0) === 0
//                             ? 'zero'
//                             : ''
//                         }
//                       >
//                         {formatCurrency(item.amount_remaining)}
//                       </span>
//                     </td>
//                   </>
//                 )}
//                 <td>
//                   <span className={`status-badge ${statusConfig.className}`}>
//                     <StatusIcon /> {statusConfig.label}
//                   </span>
//                 </td>
//                 <td>{formatDate(item.created_at)}</td>
//                 <td>
//                   <div className="action-buttons">
//                     <button
//                       className="btn btn-sm btn-view"
//                       onClick={() => handleViewDetails(item)}
//                     >
//                       <FaEye /> View
//                     </button>
//                     {!isFullyPaid && (
//                       <button
//                         className="btn btn-sm btn-disburse"
//                         onClick={() => handleOpenDisbursement(item)}
//                       >
//                         <FaPlus /> Pay
//                       </button>
//                     )}
//                   </div>
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>
//     );
//   };

//   // =============================================
//   // MAIN RENDER
//   // =============================================

//   const filteredData =
//     activeTab === 'custom'
//       ? payouts.filter(
//           (p) =>
//             !filters.search ||
//             p.artisan_name
//               ?.toLowerCase()
//               .includes(filters.search.toLowerCase()),
//         )
//       : readyMadeEarnings.filter(
//           (e) =>
//             !filters.search ||
//             e.id?.toString().includes(filters.search) ||
//             e.artisan?.name
//               ?.toLowerCase()
//               .includes(filters.search.toLowerCase()),
//         );

//   return (
//     <>
//       <FurnitureNavbar />
//       <div className="payouts-page">
//         <div className="page-header">
//           <div className="header-content">
//             <div className="header-text">
//               <h1>💰 Payout Management</h1>
//               <p>Manage artisan payouts and track disbursements</p>
//             </div>
//           </div>
//         </div>

//         <div className="tabs-container">
//           <button
//             className={`tab-btn ${activeTab === 'custom' ? 'active' : ''}`}
//             onClick={() => setActiveTab('custom')}
//           >
//             <FaProjectDiagram /> Custom Projects
//           </button>
//           <button
//             className={`tab-btn ${activeTab === 'ready-made' ? 'active' : ''}`}
//             onClick={() => setActiveTab('ready-made')}
//           >
//             <FaBox /> Ready-Made Orders
//           </button>
//         </div>

//         {renderStats(activeTab === 'custom' ? stats : readyMadeStats)}

//         <div className="filters-section">
//           <div className="filters-bar">
//             <div className="search-box">
//               <FaSearch className="search-icon" />
//               <input
//                 type="text"
//                 placeholder={`Search ${activeTab === 'custom' ? 'artisan or project' : 'ID or artisan'}...`}
//                 value={filters.search}
//                 onChange={(e) =>
//                   setFilters((prev) => ({ ...prev, search: e.target.value }))
//                 }
//               />
//             </div>
//             {activeTab === 'custom' && (
//               <select
//                 value={filters.status}
//                 onChange={(e) =>
//                   setFilters((prev) => ({ ...prev, status: e.target.value }))
//                 }
//               >
//                 <option value="all">All Status</option>
//                 <option value="pending">Pending</option>
//                 <option value="partially_paid">Partially Paid</option>
//                 <option value="paid">Paid</option>
//               </select>
//             )}
//             <button
//               className="btn btn-refresh"
//               onClick={() => {
//                 if (activeTab === 'custom') fetchPayouts();
//                 else fetchReadyMadeEarnings();
//               }}
//             >
//               🔄 Refresh
//             </button>
//           </div>
//         </div>

//         <div className="table-section">
//           <div className="table-container">
//             {loading ? (
//               <div className="loading-container">
//                 <div className="loading-spinner"></div>
//                 <p>Loading...</p>
//               </div>
//             ) : (
//               renderTable(filteredData, activeTab)
//             )}
//           </div>
//         </div>

//         {/* Detail Modal */}
//         {showDetailModal && (
//           <div className="modal-overlay" onClick={handleCloseModals}>
//             <div
//               className="modal-content detail-modal"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <div className="modal-header">
//                 <div className="modal-title">
//                   <h2>
//                     {activeTab === 'custom'
//                       ? `Payout #${selectedPayout?.id || ''}`
//                       : `Earning #${selectedEarning?.id || ''}`}
//                   </h2>
//                 </div>
//                 <button className="close-modal" onClick={handleCloseModals}>
//                   <FaTimes />
//                 </button>
//               </div>

//               <div className="modal-body">
//                 {activeTab === 'custom'
//                   ? renderCustomDetail()
//                   : renderReadyMadeDetail()}
//               </div>

//               <div className="modal-footer">
//                 <button
//                   className="btn btn-secondary"
//                   onClick={handleCloseModals}
//                 >
//                   Close
//                 </button>
//                 {activeTab === 'custom' &&
//                   selectedPayout?.status !== 'paid' &&
//                   selectedPayout?.status !== 'cancelled' && (
//                     <button
//                       className="btn btn-primary"
//                       onClick={() => {
//                         handleCloseModals();
//                         handleOpenDisbursement(selectedPayout);
//                       }}
//                     >
//                       <FaPlus /> Record Payment
//                     </button>
//                   )}
//                 {activeTab === 'ready-made' &&
//                   selectedEarning &&
//                   selectedEarning.status !== 'paid' && (
//                     <button
//                       className="btn btn-primary"
//                       onClick={() => {
//                         handleCloseModals();
//                         handleOpenDisbursement(selectedEarning);
//                       }}
//                     >
//                       <FaPlus /> Record Payment
//                     </button>
//                   )}
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Disbursement Modal */}
//         {showDisbursementModal && (
//           <div className="modal-overlay" onClick={handleCloseModals}>
//             <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//               <div className="modal-header">
//                 <h2>Record Disbursement</h2>
//                 <button className="close-modal" onClick={handleCloseModals}>
//                   <FaTimes />
//                 </button>
//               </div>

//               <form onSubmit={handleSubmit}>
//                 <div className="form-group">
//                   <label>Amount *</label>
//                   <input
//                     type="number"
//                     name="amount"
//                     value={formData.amount}
//                     onChange={handleInputChange}
//                     placeholder="Enter amount"
//                     step="0.01"
//                     min="0.01"
//                     className={formErrors.amount ? 'error' : ''}
//                     disabled={isSubmitting}
//                   />
//                   {formErrors.amount && (
//                     <span className="error-message">{formErrors.amount}</span>
//                   )}
//                 </div>

//                 <div className="form-group">
//                   <label>Payment Method *</label>
//                   <select
//                     name="payment_method"
//                     value={formData.payment_method}
//                     onChange={handleInputChange}
//                     className={formErrors.payment_method ? 'error' : ''}
//                     disabled={isSubmitting}
//                   >
//                     <option value="mpesa">M-Pesa</option>
//                     <option value="bank">Bank Transfer</option>
//                   </select>
//                   {formErrors.payment_method && (
//                     <span className="error-message">
//                       {formErrors.payment_method}
//                     </span>
//                   )}
//                 </div>

//                 <div className="form-group">
//                   <label>Transaction Reference *</label>
//                   <input
//                     type="text"
//                     name="transaction_reference"
//                     value={formData.transaction_reference}
//                     onChange={handleInputChange}
//                     placeholder="Enter transaction reference"
//                     className={formErrors.transaction_reference ? 'error' : ''}
//                     disabled={isSubmitting}
//                   />
//                   {formErrors.transaction_reference && (
//                     <span className="error-message">
//                       {formErrors.transaction_reference}
//                     </span>
//                   )}
//                 </div>

//                 <div className="form-group">
//                   <label>Notes (Optional)</label>
//                   <textarea
//                     name="notes"
//                     value={formData.notes}
//                     onChange={handleInputChange}
//                     placeholder="Any notes..."
//                     rows="2"
//                     disabled={isSubmitting}
//                   />
//                 </div>

//                 <div className="modal-actions">
//                   <button
//                     type="button"
//                     className="btn btn-secondary"
//                     onClick={handleCloseModals}
//                     disabled={isSubmitting}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     className="btn btn-primary"
//                     disabled={isSubmitting}
//                   >
//                     {isSubmitting ? 'Processing...' : 'Record Payment'}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default withAuth(PayoutsPage, 'admin');



// src/pages/admin/PayoutsPage.jsx
import React, { useState, useEffect } from 'react';
import {
  FaSearch,
  FaMoneyBillWave,
  FaClock,
  FaCheckCircle,
  FaExclamationCircle,
  FaEye,
  FaPlus,
  FaTimes,
  FaUser,
  FaReceipt,
  FaProjectDiagram,
  FaWallet,
  FaBox,
  FaPhone,
  FaUniversity,
  FaSyncAlt,
} from 'react-icons/fa';
import withAuth from '../../auth/WithAuth';
import { toast } from 'react-toastify';
import './disbursements.scss';
import { serverUrlAuth } from '../../../serverUrl';
import Sidebar from '../../../components/layout/Sidebar';

const PayoutsPage = () => {
  const [activeTab, setActiveTab] = useState('custom');
  const [payouts, setPayouts] = useState([]);
  const [readyMadeEarnings, setReadyMadeEarnings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDisbursementModal, setShowDisbursementModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedPayout, setSelectedPayout] = useState(null);
  const [selectedEarning, setSelectedEarning] = useState(null);
  const [detailData, setDetailData] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const [filters, setFilters] = useState({ status: 'all', search: '' });
  const [formData, setFormData] = useState({
    amount: '',
    payment_method: 'mpesa',
    transaction_reference: '',
    notes: '',
  });

  // Stats
  const [stats, setStats] = useState({
    total: 0,
    pending: 0,
    partially_paid: 0,
    paid: 0,
  });
  const [readyMadeStats, setReadyMadeStats] = useState({
    total: 0,
    pending: 0,
    partially_paid: 0,
    paid: 0,
  });

  // =============================================
  // FETCH FUNCTIONS
  // =============================================

  useEffect(() => {
    fetchPayouts();
    fetchReadyMadeEarnings();
  }, []);

  const fetchPayouts = async () => {
    setLoading(true);
    try {
      const url =
        filters.status !== 'all'
          ? `disbursement/payouts/?status=${filters.status}`
          : 'disbursement/payouts/';
      const response = await serverUrlAuth.get(url);
      const data = response.data;
      const payoutsData = Array.isArray(data) ? data : [];
      setPayouts(payoutsData);
      updateStats(payoutsData);
    } catch (error) {
      console.error('Error:', error);
      toast.error('Failed to load payouts');
    } finally {
      setLoading(false);
    }
  };

  const fetchReadyMadeEarnings = async () => {
    setLoading(true);
    try {
      const response = await serverUrlAuth.get(
        'disbursement/admin/ready-made-disbursements/',
      );
      const data = response.data;
      const earnings = data.earnings || [];
      setReadyMadeEarnings(earnings);
      updateReadyMadeStats(earnings);
    } catch (error) {
      console.error('Error:', error);
      toast.error('Failed to load ready-made earnings');
    } finally {
      setLoading(false);
    }
  };

  const fetchDetail = async (id, type) => {
    setDetailLoading(true);
    setDetailData(null);
    try {
      let response;
      if (type === 'custom') {
        response = await serverUrlAuth.get(`disbursement/payouts/${id}/`);
        const data = response.data;
        setDetailData({
          ...data.payout,
          disbursements: data.disbursements || [],
        });
      } else {
        response = await serverUrlAuth.get(
          `disbursement/admin/ready-made-earnings/${id}/`,
        );
        const data = response.data;
        setDetailData(data.earning || data);
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Failed to load details');
    } finally {
      setDetailLoading(false);
    }
  };

  const recordDisbursement = async (id, payload, type) => {
    let endpoint;
    if (type === 'custom') {
      endpoint = `disbursement/payouts/${id}/disburse/`;
    } else {
      endpoint = `disbursement/admin/ready-made-earnings/${id}/disburse/`;
    }
    const response = await serverUrlAuth.post(endpoint, payload);
    return response.data;
  };

  // =============================================
  // UI FUNCTIONS
  // =============================================

  const updateStats = (data) => {
    setStats({
      total: data.length,
      pending: data.filter((p) => p.status === 'pending').length,
      partially_paid: data.filter((p) => p.status === 'partially_paid').length,
      paid: data.filter((p) => p.status === 'paid').length,
    });
  };

  const updateReadyMadeStats = (data) => {
    setReadyMadeStats({
      total: data.length,
      pending: data.filter((e) => e.status === 'pending').length,
      partially_paid: data.filter((e) => e.status === 'partially_paid').length,
      paid: data.filter((e) => e.status === 'paid').length,
    });
  };

  const handleViewDetails = (item) => {
    if (activeTab === 'custom') {
      setSelectedPayout(item);
      fetchDetail(item.id, 'custom');
    } else {
      setSelectedEarning(item);
      fetchDetail(item.id, 'ready-made');
    }
    setShowDetailModal(true);
  };

  const handleOpenDisbursement = (item) => {
    if (activeTab === 'custom') {
      setSelectedPayout(item);
    } else {
      setSelectedEarning(item);
    }

    const remaining =
      activeTab === 'custom'
        ? parseFloat(item.amount_remaining) || 0
        : (parseFloat(item.net_amount) || 0) -
          (parseFloat(item.amount_disbursed) || 0);

    setFormData({
      amount: remaining > 0 ? remaining.toString() : '',
      payment_method: 'mpesa',
      transaction_reference: '',
      notes: '',
    });
    setFormErrors({});
    setShowDisbursementModal(true);
  };

  const handleCloseModals = () => {
    setShowDetailModal(false);
    setShowDisbursementModal(false);
    setSelectedPayout(null);
    setSelectedEarning(null);
    setDetailData(null);
    setFormData({
      amount: '',
      payment_method: 'mpesa',
      transaction_reference: '',
      notes: '',
    });
    setFormErrors({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const errors = {};
    const amount = parseFloat(formData.amount);

    let maxAmount = 0;
    if (activeTab === 'custom' && selectedPayout) {
      maxAmount = parseFloat(selectedPayout.amount_remaining) || 0;
    } else if (activeTab === 'ready-made' && selectedEarning) {
      maxAmount =
        (parseFloat(selectedEarning.net_amount) || 0) -
        (parseFloat(selectedEarning.amount_disbursed) || 0);
    }

    if (!formData.amount) errors.amount = 'Amount is required';
    else if (isNaN(amount) || amount <= 0)
      errors.amount = 'Amount must be greater than 0';
    else if (amount > maxAmount)
      errors.amount = `Amount exceeds remaining balance (${formatCurrency(maxAmount)})`;
    if (!formData.payment_method)
      errors.payment_method = 'Payment method is required';
    if (!formData.transaction_reference)
      errors.transaction_reference = 'Transaction reference is required';

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = {
        amount: parseFloat(formData.amount),
        payment_method: formData.payment_method,
        transaction_reference: formData.transaction_reference,
        notes: formData.notes,
      };

      let id;
      if (activeTab === 'custom' && selectedPayout) {
        id = selectedPayout.id;
      } else if (activeTab === 'ready-made' && selectedEarning) {
        id = selectedEarning.id;
      } else {
        toast.error('No item selected');
        return;
      }

      await recordDisbursement(id, payload, activeTab);
      toast.success('Disbursement recorded successfully!');

      if (activeTab === 'custom') {
        await fetchPayouts();
      } else {
        await fetchReadyMadeEarnings();
      }

      handleCloseModals();
    } catch (error) {
      console.error('Error:', error);
      toast.error(
        error.response?.data?.error || 'Failed to record disbursement',
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // =============================================
  // HELPERS
  // =============================================

  const getStatusConfig = (status) => {
    const configs = {
      pending: {
        label: 'Pending',
        icon: FaClock,
        className: 'status-pending',
        color: '#b8860b',
        bg: 'rgba(184, 134, 11, 0.14)',
      },
      partially_paid: {
        label: 'Partially Paid',
        icon: FaExclamationCircle,
        className: 'status-partial',
        color: '#8a5018',
        bg: 'rgba(138, 80, 24, 0.12)',
      },
      paid: {
        label: 'Paid',
        icon: FaCheckCircle,
        className: 'status-paid',
        color: '#6b8e23',
        bg: 'rgba(107, 142, 35, 0.14)',
      },
      cancelled: {
        label: 'Cancelled',
        icon: FaExclamationCircle,
        className: 'status-cancelled',
        color: '#8b2e1a',
        bg: 'rgba(139, 46, 26, 0.12)',
      },
    };
    return configs[status] || configs.pending;
  };

  const formatCurrency = (amount) => {
    if (amount === undefined || amount === null || isNaN(amount))
      return 'KES 0.00';
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES',
      minimumFractionDigits: 2,
    }).format(parseFloat(amount));
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    try {
      return new Date(date).toLocaleDateString('en-KE', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return 'N/A';
    }
  };

  // =============================================
  // RENDER FUNCTIONS
  // =============================================

  const renderStats = (statsData) => (
    <div className="stats-overview">
      {['total', 'pending', 'partially_paid', 'paid'].map((key) => (
        <div key={key} className={`stat-card ${key}`}>
          <div className="stat-icon">
            {key === 'total' && <FaMoneyBillWave />}
            {key === 'pending' && <FaClock />}
            {key === 'partially_paid' && <FaExclamationCircle />}
            {key === 'paid' && <FaCheckCircle />}
          </div>
          <div className="stat-info">
            <h3>
              {key === 'total'
                ? 'Total'
                : key === 'partially_paid'
                ? 'Partially Paid'
                : key.charAt(0).toUpperCase() + key.slice(1)}
            </h3>
            <p className="stat-value">{statsData[key]}</p>
          </div>
        </div>
      ))}
    </div>
  );

  // Render Payment Details Section
  const renderPaymentDetails = (paymentDetails) => {
    if (!paymentDetails) {
      return (
        <div className="payment-details-empty">
          <FaWallet className="empty-icon" />
          <p>No payment details available</p>
          <span className="empty-sub">
            Artisan hasn't set up payment method yet
          </span>
        </div>
      );
    }

    const isMpesa = paymentDetails.payment_method === 'mpesa';

    return (
      <div className="payment-details-grid">
        <div className="payment-method-badge">
          <span className={`method-badge ${isMpesa ? 'mpesa' : 'bank'}`}>
            {isMpesa ? (
              <>
                <FaPhone className="method-icon" /> M-Pesa
              </>
            ) : (
              <>
                <FaUniversity className="method-icon" /> Bank Transfer
              </>
            )}
          </span>
        </div>

        <div className="payment-details-list">
          {isMpesa ? (
            <>
              <div className="detail-item">
                <span className="label">Phone Number</span>
                <span className="value phone-number">
                  {paymentDetails.mpesa_phone_number || 'N/A'}
                </span>
              </div>
              {paymentDetails.mpesa_name && (
                <div className="detail-item">
                  <span className="label">Account Name</span>
                  <span className="value">{paymentDetails.mpesa_name}</span>
                </div>
              )}
            </>
          ) : (
            <>
              <div className="detail-item">
                <span className="label">Bank Name</span>
                <span className="value bank-name">
                  {paymentDetails.bank_name || 'N/A'}
                </span>
              </div>
              <div className="detail-item">
                <span className="label">Account Name</span>
                <span className="value">
                  {paymentDetails.bank_account_name || 'N/A'}
                </span>
              </div>
              <div className="detail-item">
                <span className="label">Account Number</span>
                <span className="value account-number">
                  {paymentDetails.bank_account_number || 'N/A'}
                </span>
              </div>
              {paymentDetails.bank_branch && (
                <div className="detail-item">
                  <span className="label">Branch</span>
                  <span className="value">{paymentDetails.bank_branch}</span>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  };

  // Render Disbursement History (shared between custom and ready-made)
  const renderDisbursementHistory = (disbursements) => {
    if (!disbursements || disbursements.length === 0) {
      return (
        <div className="no-disbursements">
          <p>No disbursements recorded yet.</p>
        </div>
      );
    }

    return (
      <div className="disbursement-list">
        {disbursements.map((d, i) => (
          <div key={d.id || i} className="disbursement-item">
            <div className="disb-header">
              <span className="disb-number">#{i + 1}</span>
              <span className="disb-amount">
                {formatCurrency(d.amount)}
              </span>
              <span className={`disb-method ${d.payment_method || 'mpesa'}`}>
                {d.payment_method === 'mpesa' ? '📱 M-Pesa' : '🏦 Bank Transfer'}
              </span>
              <span className="disb-date">
                {formatDate(d.disbursed_at)}
              </span>
            </div>
            <div className="disb-body">
              <div className="disb-reference">
                <span className="ref-label">Reference:</span>
                <span className="ref-value">
                  {d.transaction_reference || 'N/A'}
                </span>
              </div>
              {d.recorded_by_name && (
                <div className="disb-recorded">
                  <span className="ref-label">Recorded by:</span>
                  <span className="ref-value">
                    {d.recorded_by_name}
                  </span>
                </div>
              )}
              {d.project_name && (
                <div className="disb-project">
                  <span className="ref-label">Project:</span>
                  <span className="ref-value">
                    {d.project_name}
                  </span>
                </div>
              )}
              {d.payout_stage && (
                <div className="disb-stage">
                  <span className="ref-label">Stage:</span>
                  <span className="ref-value">
                    {d.payout_stage}
                  </span>
                </div>
              )}
            </div>
            {d.notes && (
              <div className="disb-notes">
                <span className="notes-label">Notes:</span>
                <span className="notes-value">{d.notes}</span>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  // Custom Project Detail
  const renderCustomDetail = () => {
    if (detailLoading) {
      return (
        <div className="detail-loading">
          <div className="loading-spinner-small"></div>
          <p>Loading details...</p>
        </div>
      );
    }

    if (!detailData) {
      return (
        <div className="detail-error">
          <FaExclamationCircle className="error-icon" />
          <p>Failed to load details.</p>
        </div>
      );
    }

    const data = detailData;
    const statusConfig = getStatusConfig(data.status);
    const StatusIcon = statusConfig.icon;

    return (
      <div className="detail-content">
        {/* Header Card */}
        <div className="detail-header-card">
          <div className="header-left">
            <div className="payout-id">Payout #{data.id}</div>
            <div className="payout-title">
              {data.project_name || 'Custom Project'}
            </div>
          </div>
          <div className="header-right">
            <span className={`status-badge ${statusConfig.className}`}>
              <StatusIcon /> {statusConfig.label}
            </span>
          </div>
        </div>

        <div className="detail-two-column">
          <div className="detail-column-left">
            {/* Project Information */}
            <div className="detail-section">
              <div className="section-header">
                <FaProjectDiagram className="section-icon" />
                <h3 className="section-title">Project Information</h3>
              </div>
              <div className="detail-grid">
                <div className="detail-item">
                  <span className="label">Project Name</span>
                  <span className="value">{data.project_name || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Project ID</span>
                  <span className="value">#{data.project_id || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Stage</span>
                  <span className="value stage-badge">
                    {data.payout_stage || 'N/A'}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="label">Payment ID</span>
                  <span className="value">#{data.payment || 'N/A'}</span>
                </div>
              </div>
            </div>

            {/* Artisan Information */}
            <div className="detail-section">
              <div className="section-header">
                <FaUser className="section-icon" />
                <h3 className="section-title">Artisan Information</h3>
              </div>
              <div className="detail-grid">
                <div className="detail-item">
                  <span className="label">Name</span>
                  <span className="value">{data.artisan_name || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Artisan ID</span>
                  <span className="value">#{data.artisan || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Created</span>
                  <span className="value">{formatDate(data.created_at)}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Updated</span>
                  <span className="value">{formatDate(data.updated_at)}</span>
                </div>
              </div>
            </div>

            {/* Payment Details */}
            <div className="detail-section">
              <div className="section-header">
                <FaWallet className="section-icon" />
                <h3 className="section-title">Payment Details</h3>
              </div>
              {renderPaymentDetails(data.artisan_payment_details)}
            </div>
          </div>

          <div className="detail-column-right">
            {/* Financial Summary */}
            <div className="detail-section">
              <div className="section-header">
                <FaMoneyBillWave className="section-icon" />
                <h3 className="section-title">Financial Summary</h3>
              </div>
              <div className="financial-grid">
                <div className="financial-item">
                  <span className="label">Gross Amount</span>
                  <span className="value">
                    {formatCurrency(data.gross_amount)}
                  </span>
                </div>
                <div className="financial-item">
                  <span className="label">Commission</span>
                  <span className="value text-muted">
                    {formatCurrency(data.commission_amount)}
                  </span>
                </div>
                <div className="financial-item highlight">
                  <span className="label">Artisan Amount</span>
                  <span className="value">
                    {formatCurrency(data.artisan_amount)}
                  </span>
                </div>
                <div className="financial-item">
                  <span className="label">Disbursed</span>
                  <span className="value text-success">
                    {formatCurrency(data.amount_disbursed)}
                  </span>
                </div>
                <div className="financial-item highlight-remaining">
                  <span className="label">Remaining</span>
                  <span className="value">
                    {formatCurrency(data.amount_remaining)}
                  </span>
                </div>
              </div>
            </div>

            {/* Disbursement History */}
            <div className="detail-section">
              <div className="section-header">
                <FaReceipt className="section-icon" />
                <h3 className="section-title">Disbursement History</h3>
                {data.disbursements && data.disbursements.length > 0 && (
                  <span className="disbursement-count">
                    {data.disbursements.length}
                  </span>
                )}
              </div>
              {renderDisbursementHistory(data.disbursements)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Ready-Made Detail
  const renderReadyMadeDetail = () => {
    if (detailLoading) {
      return (
        <div className="detail-loading">
          <div className="loading-spinner-small"></div>
          <p>Loading details...</p>
        </div>
      );
    }

    if (!detailData) {
      return (
        <div className="detail-error">
          <FaExclamationCircle className="error-icon" />
          <p>Failed to load details.</p>
        </div>
      );
    }

    const data = detailData;
    const statusConfig = getStatusConfig(data.status || 'pending');
    const StatusIcon = statusConfig.icon;
    const paymentDetails = data.artisan_payment_details || data.payment_details;

    return (
      <div className="detail-content">
        {/* Header Card */}
        <div className="detail-header-card ready-made-header">
          <div className="header-left">
            <div className="payout-id">Earning #{data.id}</div>
            <div className="payout-title">Ready-Made Order</div>
          </div>
          <div className="header-right">
            <span className={`status-badge ${statusConfig.className}`}>
              <StatusIcon /> {statusConfig.label}
            </span>
          </div>
        </div>

        {/* Amount Summary Card */}
        <div className="amount-summary-card">
          <div className="amount-item">
            <span className="amount-label">Net Amount</span>
            <span className="amount-value net">
              {formatCurrency(data.net_amount)}
            </span>
          </div>
          <div className="amount-divider"></div>
          <div className="amount-item">
            <span className="amount-label">Disbursed</span>
            <span className="amount-value disbursed">
              {formatCurrency(data.amount_disbursed)}
            </span>
          </div>
          <div className="amount-divider"></div>
          <div className="amount-item">
            <span className="amount-label">Remaining</span>
            <span className="amount-value remaining">
              {formatCurrency(data.amount_remaining)}
            </span>
          </div>
        </div>

        <div className="detail-two-column">
          <div className="detail-column-left">
            {/* Artisan Information */}
            <div className="detail-section">
              <div className="section-header">
                <FaUser className="section-icon" />
                <h3 className="section-title">Artisan Information</h3>
              </div>
              <div className="detail-grid">
                <div className="detail-item">
                  <span className="label">Name</span>
                  <span className="value">{data.artisan?.name || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Email</span>
                  <span className="value">{data.artisan?.email || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Artisan ID</span>
                  <span className="value">#{data.artisan?.id || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Status</span>
                  <span className={`status-badge ${statusConfig.className}`}>
                    <StatusIcon /> {statusConfig.label}
                  </span>
                </div>
              </div>
            </div>

            {/* Payment Details */}
            <div className="detail-section">
              <div className="section-header">
                <FaWallet className="section-icon" />
                <h3 className="section-title">Payment Details</h3>
              </div>
              {renderPaymentDetails(paymentDetails)}
            </div>

            {/* Order Information */}
            <div className="detail-section">
              <div className="section-header">
                <FaBox className="section-icon" />
                <h3 className="section-title">Order Information</h3>
              </div>
              <div className="detail-grid">
                <div className="detail-item">
                  <span className="label">Earning ID</span>
                  <span className="value">#{data.id}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Artisan Order</span>
                  <span className="value">
                    #{data.artisan_order?.id || 'N/A'}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="label">Customer Order</span>
                  <span className="value">
                    #{data.artisan_order?.customer_order_id || 'N/A'}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="label">Created</span>
                  <span className="value">{formatDate(data.created_at)}</span>
                </div>
                {data.paid_at && (
                  <div className="detail-item full-width">
                    <span className="label">Paid At</span>
                    <span className="value">{formatDate(data.paid_at)}</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="detail-column-right">
            {/* Financial Breakdown */}
            <div className="detail-section">
              <div className="section-header">
                <FaMoneyBillWave className="section-icon" />
                <h3 className="section-title">Financial Breakdown</h3>
              </div>
              <div className="financial-breakdown">
                <div className="breakdown-item">
                  <span className="breakdown-label">Gross Amount</span>
                  <span className="breakdown-value">
                    {formatCurrency(data.gross_amount)}
                  </span>
                </div>
                <div className="breakdown-item">
                  <span className="breakdown-label">Commission</span>
                  <span className="breakdown-value negative">
                    -{formatCurrency(data.commission_amount)}
                  </span>
                </div>
                <div className="breakdown-item total">
                  <span className="breakdown-label">Net Amount</span>
                  <span className="breakdown-value">
                    {formatCurrency(data.net_amount)}
                  </span>
                </div>
              </div>
            </div>

            {/* Disbursement History */}
            <div className="detail-section">
              <div className="section-header">
                <FaReceipt className="section-icon" />
                <h3 className="section-title">Disbursement History</h3>
                {data.disbursements && data.disbursements.length > 0 && (
                  <span className="disbursement-count">
                    {data.disbursements.length}
                  </span>
                )}
              </div>
              {renderDisbursementHistory(data.disbursements)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderTable = (data, type) => {
    if (data.length === 0) {
      return (
        <div className="empty-state">
          <div className="empty-icon">{type === 'custom' ? '💰' : '📦'}</div>
          <h3>No {type === 'custom' ? 'payouts' : 'earnings'} found</h3>
        </div>
      );
    }

    const isCustom = type === 'custom';

    return (
      <table className="payouts-table">
        <thead>
          <tr>
            {isCustom ? (
              <>
                <th>Artisan</th>
                <th>Project</th>
                <th>Total</th>
                <th>Disbursed</th>
                <th>Remaining</th>
                <th>Status</th>
                <th>Date</th>
                <th>Actions</th>
              </>
            ) : (
              <>
                <th>ID</th>
                <th>Artisan</th>
                <th>Gross</th>
                <th>Commission</th>
                <th>Net</th>
                <th>Disbursed</th>
                <th>Remaining</th>
                <th>Status</th>
                <th>Date</th>
                <th>Actions</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {data.map((item) => {
            const statusConfig = getStatusConfig(item.status || 'pending');
            const StatusIcon = statusConfig.icon;
            const isFullyPaid =
              item.status === 'paid' || item.status === 'cancelled';

            return (
              <tr key={item.id}>
                {isCustom ? (
                  <>
                    <td>
                      <div className="artisan-info">
                        <div className="artisan-avatar">
                          {item.artisan_name?.charAt(0) || 'A'}
                        </div>
                        <div className="artisan-details">
                          <strong>
                            {item.artisan_name || `Artisan #${item.artisan}`}
                          </strong>
                        </div>
                      </div>
                    </td>
                    <td>
                      <strong>{item.project_name || 'N/A'}</strong>
                    </td>
                    <td className="amount-column">
                      {formatCurrency(item.gross_amount)}
                    </td>
                    <td className="amount-column">
                      {formatCurrency(item.amount_disbursed)}
                    </td>
                    <td className="amount-column">
                      <span
                        className={
                          parseFloat(item.amount_remaining) === 0 ? 'zero' : ''
                        }
                      >
                        {formatCurrency(item.amount_remaining)}
                      </span>
                    </td>
                  </>
                ) : (
                  <>
                    <td>
                      <strong>#{item.id}</strong>
                    </td>
                    <td>
                      <div className="artisan-info">
                        <div className="artisan-avatar">
                          {item.artisan?.name?.charAt(0) || 'A'}
                        </div>
                        <div className="artisan-details">
                          <strong>{item.artisan?.name || 'N/A'}</strong>
                          <span>{item.artisan?.email || ''}</span>
                        </div>
                      </div>
                    </td>
                    <td className="amount-column">
                      {formatCurrency(item.gross_amount)}
                    </td>
                    <td className="amount-column">
                      {formatCurrency(item.commission_amount)}
                    </td>
                    <td className="amount-column">
                      <strong>{formatCurrency(item.net_amount)}</strong>
                    </td>
                    <td className="amount-column">
                      {formatCurrency(item.amount_disbursed)}
                    </td>
                    <td className="amount-column">
                      <span
                        className={
                          parseFloat(item.amount_remaining || 0) === 0
                            ? 'zero'
                            : ''
                        }
                      >
                        {formatCurrency(item.amount_remaining)}
                      </span>
                    </td>
                  </>
                )}
                <td>
                  <span className={`status-badge ${statusConfig.className}`}>
                    <StatusIcon /> {statusConfig.label}
                  </span>
                </td>
                <td>{formatDate(item.created_at)}</td>
                <td>
                  <div className="action-buttons">
                    <button
                      className="btn btn-sm btn-view"
                      onClick={() => handleViewDetails(item)}
                    >
                      <FaEye /> View
                    </button>
                    {!isFullyPaid && (
                      <button
                        className="btn btn-sm btn-disburse"
                        onClick={() => handleOpenDisbursement(item)}
                      >
                        <FaPlus /> Pay
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  // =============================================
  // MAIN RENDER
  // =============================================

  const filteredData =
    activeTab === 'custom'
      ? payouts.filter(
          (p) =>
            !filters.search ||
            p.artisan_name
              ?.toLowerCase()
              .includes(filters.search.toLowerCase()),
        )
      : readyMadeEarnings.filter(
          (e) =>
            !filters.search ||
            e.id?.toString().includes(filters.search) ||
            e.artisan?.name
              ?.toLowerCase()
              .includes(filters.search.toLowerCase()),
        );

  return (
    <>
      <Sidebar />
      <div className="payouts-page">
        {/* ============ PAGE HEADER ============ */}
        <div className="page-header">
          <div className="header-content">
            <div className="header-text">
              <span className="eyebrow">Admin · Payouts</span>
              <h1>Payout Management</h1>
              <p>Manage artisan payouts and track disbursements</p>
            </div>
          </div>
        </div>

        {/* ============ TABS ============ */}
        <div className="tabs-container">
          <button
            className={`tab-btn ${activeTab === 'custom' ? 'active' : ''}`}
            onClick={() => setActiveTab('custom')}
          >
            <FaProjectDiagram /> Custom Projects
          </button>
          <button
            className={`tab-btn ${activeTab === 'ready-made' ? 'active' : ''}`}
            onClick={() => setActiveTab('ready-made')}
          >
            <FaBox /> Ready-Made Orders
          </button>
        </div>

        {/* ============ STATS ============ */}
        {renderStats(activeTab === 'custom' ? stats : readyMadeStats)}

        {/* ============ FILTERS ============ */}
        <div className="filters-section">
          <div className="filters-bar">
            <div className="search-box">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder={`Search ${
                  activeTab === 'custom' ? 'artisan or project' : 'ID or artisan'
                }...`}
                value={filters.search}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, search: e.target.value }))
                }
              />
            </div>
            {activeTab === 'custom' && (
              <select
                value={filters.status}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, status: e.target.value }))
                }
              >
                <option value="all">All Status</option>
                <option value="pending">Pending</option>
                <option value="partially_paid">Partially Paid</option>
                <option value="paid">Paid</option>
              </select>
            )}
            <button
              className="btn btn-refresh"
              onClick={() => {
                if (activeTab === 'custom') fetchPayouts();
                else fetchReadyMadeEarnings();
              }}
            >
              <FaSyncAlt /> Refresh
            </button>
          </div>
        </div>

        {/* ============ TABLE ============ */}
        <div className="table-section">
          <div className="table-container">
            {loading ? (
              <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Loading…</p>
              </div>
            ) : (
              renderTable(filteredData, activeTab)
            )}
          </div>
        </div>

        {/* ============ DETAIL MODAL ============ */}
        {showDetailModal && (
          <div className="modal-overlay" onClick={handleCloseModals}>
            <div
              className="modal-content detail-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-header">
                <div className="modal-title">
                  <h2>
                    {activeTab === 'custom'
                      ? `Payout #${selectedPayout?.id || ''}`
                      : `Earning #${selectedEarning?.id || ''}`}
                  </h2>
                </div>
                <button className="close-modal" onClick={handleCloseModals}>
                  <FaTimes />
                </button>
              </div>

              <div className="modal-body">
                {activeTab === 'custom'
                  ? renderCustomDetail()
                  : renderReadyMadeDetail()}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={handleCloseModals}
                >
                  Close
                </button>
                {activeTab === 'custom' &&
                  selectedPayout?.status !== 'paid' &&
                  selectedPayout?.status !== 'cancelled' && (
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        handleCloseModals();
                        handleOpenDisbursement(selectedPayout);
                      }}
                    >
                      <FaPlus /> Record Payment
                    </button>
                  )}
                {activeTab === 'ready-made' &&
                  selectedEarning &&
                  selectedEarning.status !== 'paid' && (
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        handleCloseModals();
                        handleOpenDisbursement(selectedEarning);
                      }}
                    >
                      <FaPlus /> Record Payment
                    </button>
                  )}
              </div>
            </div>
          </div>
        )}

        {/* ============ DISBURSEMENT MODAL ============ */}
        {showDisbursementModal && (
          <div className="modal-overlay" onClick={handleCloseModals}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>Record Disbursement</h2>
                <button className="close-modal" onClick={handleCloseModals}>
                  <FaTimes />
                </button>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Amount *</label>
                  <input
                    type="number"
                    name="amount"
                    value={formData.amount}
                    onChange={handleInputChange}
                    placeholder="Enter amount"
                    step="0.01"
                    min="0.01"
                    className={formErrors.amount ? 'error' : ''}
                    disabled={isSubmitting}
                  />
                  {formErrors.amount && (
                    <span className="error-message">{formErrors.amount}</span>
                  )}
                </div>

                <div className="form-group">
                  <label>Payment Method *</label>
                  <select
                    name="payment_method"
                    value={formData.payment_method}
                    onChange={handleInputChange}
                    className={formErrors.payment_method ? 'error' : ''}
                    disabled={isSubmitting}
                  >
                    <option value="mpesa">M-Pesa</option>
                    <option value="bank">Bank Transfer</option>
                  </select>
                  {formErrors.payment_method && (
                    <span className="error-message">
                      {formErrors.payment_method}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>Transaction Reference *</label>
                  <input
                    type="text"
                    name="transaction_reference"
                    value={formData.transaction_reference}
                    onChange={handleInputChange}
                    placeholder="Enter transaction reference"
                    className={formErrors.transaction_reference ? 'error' : ''}
                    disabled={isSubmitting}
                  />
                  {formErrors.transaction_reference && (
                    <span className="error-message">
                      {formErrors.transaction_reference}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>Notes (Optional)</label>
                  <textarea
                    name="notes"
                    value={formData.notes}
                    onChange={handleInputChange}
                    placeholder="Any notes..."
                    rows="2"
                    disabled={isSubmitting}
                  />
                </div>

                <div className="modal-actions">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCloseModals}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Processing...' : 'Record Payment'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default withAuth(PayoutsPage, 'admin');